// reference: $\src\js\utils.js
// Helper function to get delivery information from line item properties
function getDeliveryInformation(line) {
    var deliveryMessage = "";
    var transitInfo = "";
    var hasDeliveryInfo = false;
    var isCustomOrder = false;
    var customizationShippingMessage = "";
    
    if (line.properties != null && line.properties.length > 0) {
        line.properties.forEach((prop) => {
            if (prop.name === "_delivery") {
                deliveryMessage = prop.value;
                hasDeliveryInfo = true;
            } else if (prop.name === "_transit") {
                transitInfo = prop.value;
                hasDeliveryInfo = true;
            } else if (prop.name.indexOf('__CustomizationShippingMessage') >= 0) {
                customizationShippingMessage = prop.value;
            } else if (prop.name.indexOf('TeamStore_') >= 0
                        && (prop.name.indexOf('__Personalization') >= 0 && prop.value.indexOf('Y') >= 0)) {
                isCustomOrder = true;
            } else if (prop.name.indexOf('_CustomizationId') >= 0 && !isNaN(prop.value) && String(prop.value).trim() !== '') {
                // Check if _CustomizationId exists and has a numeric value (not empty)
                // This indicates the item actually needs customization, not just that it can be customized
                isCustomOrder = true;
            }
        });
    }
    
    // If we have delivery info (both properties come as a couple)
    if (hasDeliveryInfo) {
        // Return delivery message if available
        if (deliveryMessage) {
            return deliveryMessage;
        } else if (transitInfo) {
            // Parse transit info if delivery message not available
            try {
                var transitDays = JSON.parse(transitInfo);
                if (Array.isArray(transitDays) && transitDays.length === 2) {
                    var minDays = transitDays[0];
                    var maxDays = transitDays[1];
                    return "Estimated Shipment: " + minDays + "-" + maxDays + " business days";
                }
            } catch (e) {
                // If parsing fails, use transit info as is
                return "Transit: " + transitInfo;
            }
        }
    }
    
    // Check for customization shipping message if this is a custom order
    if (isCustomOrder) {
        if (customizationShippingMessage && customizationShippingMessage !== "") {
            return customizationShippingMessage;
        }
        
        // CustomizationShippingMessage is always 8-10 Business days if the order is after 9/20/2024 SWIMOUTLET-59608
        // SO-62820 Changed to 10-15 
        var compareDate = new Date("2024-09-20");
        var orderCreatedAt = new Date(line.created_at || new Date());
        if (orderCreatedAt > compareDate) {
            return document.querySelector(".customization_msg_allow_businessdays")?.value ?? "";
        }
    }
    
    // Return null if no delivery information available
    return null;
}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

var se_myaccount = se_myaccount || {};
se_myaccount.Utils = {
    addNewAddress: function() {

    }
}

var photoURL = "https://photos.cdn-outlet.com/";
if(config_domain == "alpha.swimoutlet.com"){
    photoURL = "https://gcp-www.swimoutlet.com/";
}


function getApiToken() {
    return new Promise((resolve, reject) => {
        let apiKey = Cookies.get('apikey');
        if (apiKey) {
            if (apiKey.startsWith('"')) {
                apiKey = JSON.parse(apiKey);
            }
            resolve(apiKey);
            return;
        }

        var url = SEEndpointURL + 'api/token?key=' + Math.random();
        fetch(url)
            .then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem with apikey-generator(). Status Code: ' + response.status);
                        return;
                    }
                    response.json().then(function(data) {

                        Cookies.set('apikey', data, { expires: 7, path: '/', secure: true })
                        resolve(data);
                    });
                }
            )
            .catch(reject);

    });
}

function getLoginApiToken() {
    return new Promise((resolve, reject) => {
        var in60Minutes = 1 / 24;
        var cntoken = "apitoken",
            cntoken_customer = "apitoken_customerid",
            cnteam = "dashboard_teamid",
            cnteam_customer = "dashboard_teamid_customerid";
        var cvtoken = Cookies.get(cntoken),
            cvtoken_customer = parseInt(Cookies.get(cntoken_customer)),
            cvteam = parseInt(Cookies.get(cnteam)),
            cvteam_customer = parseInt(Cookies.get(cnteam_customer));
        if (cvteam) {
            if (!cvteam_customer) {
                Cookies.set(cnteam_customer, ShopifyCustomerId);
            } else if (cvteam_customer !== ShopifyCustomerId) { // case: Login Multipass
                console.log(`[ get-login-api-token ] cvteam = ${cvteam}, cvteam-customer = ${cvteam_customer}, customer-id-shopify = ${ShopifyCustomerId}`);
                //Cookies.remove(cnteam);
                Cookies.remove(cnteam_customer);
            }
        }
        if (ShopifyCustomerId == 0) {
            Cookies.remove(cntoken);
            Cookies.remove(cntoken_customer);
            //Cookies.remove(cnteam);
            Cookies.remove(cnteam_customer);
            resolve(""); return;
        }
        if (cvtoken) {
            if (!cvtoken_customer) {
                Cookies.set(cntoken_customer, ShopifyCustomerId, { expires: in60Minutes, path: '/', secure: true });
            } else if (cvtoken_customer !== ShopifyCustomerId) { // case: Login Multipass
                console.log(`[ get-login-api-token ] cvtoken = ${cvtoken}, cvtoken-customer = ${cvtoken_customer}, customer-id-shopify = ${ShopifyCustomerId}`);
                Cookies.remove(cntoken); cvtoken = "";
                Cookies.remove(cntoken_customer); cvtoken_customer = 0;
            }

            if (cvtoken.startsWith('"')) {
                cvtoken = JSON.parse(cvtoken);
            }
            if (cvtoken) {
                resolve(cvtoken); return;
            }
        }
        Cookies.remove(cntoken);
        Cookies.remove(cntoken_customer);
        //Cookies.remove(cnteam);
        Cookies.remove(cnteam_customer);
        var _data = { "cusid": ShopifyCustomerId.toString(), "secretkey": ShopifyCustomerKey };
        var _url = SEEndpointURL + 'api/token/account?key=' + Math.random();
        fetch(_url, { method: 'POST', headers: { 'Content-Type': 'application/json', }, body: JSON.stringify(_data), })
            .then(
                function(response) {
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem with apitoken-generator(). Status Code: ' + response.status);
                        resolve("");
                        return;
                    }
                    response.json().then(function(data) {
                        if (data != null && data != "") {
                            Cookies.set(cntoken, data, { expires: in60Minutes, path: '/', secure: true });
                            resolve(data);
                        } else
                            resolve("");
                    });
                }
            )
            .catch(reject);
    });
}

function getTeamInfo() {
    return new Promise((resolve, reject) => {
        let fmain = (loop) => {
            getLoginApiToken().then(token => { if (token) {
                let team_id = parseInt(Cookies.get("dashboard_teamid")) || 0;
                var data = { 'customer-id-shopify': ShopifyCustomerId, 'team-id': team_id };
                var url = `${SEEndpointURL}api/fundraiser/common_info`;
                fetch(url, { method: "post", headers: { "Content-Type": "application/json", "apitoken": token, "skey": ShopifyCustomerKey }, body: JSON.stringify(data) })
                    .then(res => {
                        if (res.ok) { res.json().then(function (dataf) {
                            resolve(dataf.Data);
                        }); } else { res.text().then(function (dataf) {
                            console.log("[ team-info ] loop:", loop, ", status:", res.status, ", text:", dataf);
                            if (res.status == 500 && /invalid signature/i.test(dataf) && loop < 1) {
                                Cookies.remove("apitoken");
                                fmain(loop + 1);
                            }
                        }); }
                    }).catch(reject);
                }
            }).catch(reject);
        }; fmain(0);
    });
}

function js_RoundNumber(number) {
    var v = (number + "").replace(/,/g, "");
    var newnumber = parseFloat(v).toFixed(2);
    newnumber = newnumber.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    return newnumber;
}

function hideAllElements(elsContext) {
    var elems = document.querySelectorAll(elsContext);
    [].forEach.call(elems, function(el) {
        if (el) {
            el.style.display = 'none';
        }
    });
}

function hideElement(elContext) {
    var el = document.querySelector(elContext);
    if (el) {
        el.style.display = 'none';
    }
}

function showElement(elContext) {
    var el = document.querySelector(elContext);
    if (el) {
        el.style.display = 'block';
    }
}

function sendEvent(elContext, eventName) {
    var el = document.querySelector(elContext);
    if (el) {
        var event = new Event(eventName);
        el.dispatchEvent(event);
    }
}

function changeEmail() {
    hideElement(".account--info");
    showElement(".account--change-email");
}
function changeName() {
    hideElement(".account--info");
    showElement(".account--change-name");
}

//SWIMOUTLET-50516-Create Storefront Account Switcher for Team Admins
function displayAccount() {
    var el = document.querySelectorAll(".sidebar-acc-switcher");
    for (var i = 0; i < el.length; ++i) {
        if (el[i].classList.contains('show')) {
            el[i].classList.remove("show");
        }
        else {
            el[i].classList.add("show");
        }
    }
    syncTeamSwitcherToggleTooltip();
}

/**
 * SO-65712: Tooltip on collapsed-rail avatar (team name).
 */
function syncTeamSwitcherToggleTooltip() {
    var toggles = document.querySelectorAll('.sidebar-acc-switcher__toggle');
    for (var i = 0; i < toggles.length; i++) {
        var titleEl = toggles[i].querySelector('.acc-switcher-text');
        var teamName = titleEl ? (titleEl.textContent || '').trim() : '';
        if (teamName) {
            toggles[i].setAttribute('title', teamName);
            toggles[i].setAttribute('aria-label', 'Switch account: ' + teamName);
        }
    }
}

/**
 * SO-65712: Close account switcher flyout when clicking outside or pressing Escape.
 */
function initTeamSwitcherOutsideClose() {
    document.addEventListener('click', function(e) {
        var openSwitcher = document.querySelector('.sidebar-acc-switcher.show');
        if (!openSwitcher) return;
        if (e.target.closest('.sidebar-acc-switcher')) return;
        if (e.target.closest('[data-sidebar-toggle]')) return;
        var all = document.querySelectorAll('.sidebar-acc-switcher.show');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('show');
    }, true);
    document.addEventListener('keydown', function(e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        var all = document.querySelectorAll('.sidebar-acc-switcher.show');
        for (var i = 0; i < all.length; i++) all[i].classList.remove('show');
    });
}
function lockscreen(action, _opacity){
    let overlay = document.querySelector('#pageoverlay-top');
    overlay.style.opacity = _opacity;
    if(action == "unlock"){
        setTimeout(function(){
            overlay.classList.remove('is-visible');
        }, 500);
    }
    else{
        overlay.classList.add('is-visible');
    }
}

function validateChangeName(){
    var fname = document.getElementById("firstname").value.trim();
    var lname = document.getElementById("lastname").value.trim();
    if(!fname || !lname){
        showElement('#lblNameError');
        return false;
    }
    return true;
}

function submitChangeName(event) {
    event.preventDefault();
    event.stopPropagation();
    hideElement("#lblNameError");
    if (validateChangeName()) {
        getLoginApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var myData = {
                        'ShopifyCustomerID': ShopifyCustomerId,
                        'action': 'changeName',
                        'firstName': document.getElementById("firstname").value.trim(),
                        'lastName': document.getElementById("lastname").value.trim()
                    };
                    var url = SEEndpointURL + 'api/customer/name?key=' + Math.random();
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token,
                                'skey': ShopifyCustomerKey
                            },
                            body: JSON.stringify(myData),
                        })
                        .then(
                            function(response) {
                                if (response.status == 400) { // Bad request
                                    console.log('Looks like there was a problem with authentication. Status Code: ' +
                                        response.status);
                                    Cookies.remove("apitoken"); //clean to reset
                                    return;
                                }
                                if (response.status !== 200) {
                                    console.log('Looks like there was a problem with change email. Status Code: ' +
                                        response.status);
                                    return;
                                }

                                response.json().then(function(_data) {
                                    console.log('Success');
                                    if (_data.Meta.message == "success") {
                                        alert(" Your name is updated successfully!");
                                        hideElement("#lblNameError");
                                        setTimeout(function() { window.location.href = "/account?view=personal"; }, 2000);
                                    } else {
                                        document.getElementById("lblNameError").innerHTML = _data.Meta.message;
                                        showElement("#lblNameError");
                                    }
                                });
                            }
                        )
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });

                }

            }).catch(err => {
                console.log("Error when getting API key of change name " + err);
            });
    }
}


function validateChangeEmail() {
    var em = document.getElementById("newemail").value.trim();
    var em_again = document.getElementById("retypenewemail").value.trim();
    if (!em) {
        alert('Please input email address.');
        document.getElementById("newemail").focus();
        return false;
    } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (!regex.test(em)) {
            alert('Invalid email address, please try again.');
            document.getElementById("newemail").focus();
            return false;
        }
    }

    if (!em_again) {
        alert('Please input confirm email address.');
        document.getElementById("retypenewemail").focus();
        return false;
    } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (!regex.test(em_again)) {
            alert('Invalid confirm email address, please try again.');
            document.getElementById("retypenewemail").focus();
            return false;
        }
    }

    if (em != em_again) {
        alert('Please confirm email address again.');
        document.getElementById("retypenewemail").focus();
        return false;
    }
    return true;
}

function checkTeamStoreAcc() {

    if (Cookies.get('apitoken') != null) {
        if (ShopifyCustomerId != "" && ShopifyCustomerId != "0") {
            var myData = {
                'ShopifyCustomerID': ShopifyCustomerId
            };
            var url = SEEndpointURL + 'api/customer/checkteamstore?key=' + Math.random();

            var request = new XMLHttpRequest();
            request.open('POST', url, true);
            request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            request.setRequestHeader('apitoken', Cookies.get('apitoken'));
            request.onload = function() {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    var resp = this.response;
                    console.log('Success');
                    if (resp != null) {
                        var response = JSON.parse(resp);
                        if (response.Meta.message == "yes") {
                            showElement("#teamstore-link");
                        }
                    }
                } else {
                    // We reached our target server, but it returned an error
                    console.log(' We reached our target server, but it returned an error');

                }
            };
            request.onerror = function(error) {
                // There was a connection error of some sort
                console.log('There was a connection error of some sort');
            };
            request.send(JSON.stringify(myData));

        }
    } else {
        console.log('token is null, can not verify this account');
    }

}

function submitChangeEmail(event) {
    event.preventDefault();
    event.stopPropagation();
    //$("#lblEmailError").fadeOut();
    //$("#lblEmailNotification").fadeOut();
    hideElement("#lblEmailError");
    hideElement("#lblEmailNotification");
    if (validateChangeEmail()) {
        var CustomerSubscription = false;
        if (document.getElementById("chkKeepUpToDate").checked) {
            CustomerSubscription = true;
        }
        getLoginApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var myData = {
                        'ShopifyCustomerID': ShopifyCustomerId,
                        'action': 'changeEmail',
                        'newEmail': document.getElementById("newemail").value.trim(),
                        'CustomerSubscription': CustomerSubscription
                    };
                    var url = SEEndpointURL + 'api/customer/email?key=' + Math.random();
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token,
                                'skey': ShopifyCustomerKey
                            },
                            body: JSON.stringify(myData),
                        })
                        .then(
                            function(response) {
                                if (response.status == 400) { // Bad request
                                    console.log('Looks like there was a problem with authentication. Status Code: ' +
                                        response.status);
                                    Cookies.remove("apitoken"); //clean to reset
                                    return;
                                }
                                if (response.status !== 200) {
                                    console.log('Looks like there was a problem with change email. Status Code: ' +
                                        response.status);
                                    return;
                                }

                                response.json().then(function(_data) {
                                    console.log('Success');
                                    if (_data.Meta.message == "success") {
                                        document.getElementById("lblEmailNotification").innerHTML = " Your email address is updated successfully!";
                                        //document.getElementById("currentEmail").textContent = document.getElementById("newemail").value.trim()
                                        showElement("#lblEmailNotification");
                                        hideElement("#lblEmailError");
                                        setTimeout(function() { window.location.href = "/account?view=personal"; }, 2000);
                                    } else {
                                        document.getElementById("lblEmailError").innerHTML = _data.Meta.message;
                                        showElement("#lblEmailError");
                                        hideElement("#lblEmailNotification");
                                    }
                                });
                            }
                        )
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });

                }

            }).catch(err => {
                console.log("Error when getting API key of change_email in se-myaccount.js" + err);
            });
    }
}

function LoyaltyProgram() {
    //hideAllElements(".myaccount-sections");
    showElement("#divPlusMembership");

    // SO-67943: keep renewal block hidden until the final state is known to avoid any flash
    var hasMemberTag = typeof IsMembershipActive !== 'undefined' && IsMembershipActive;
    var renewBlockEl = document.querySelector('.membership-plus__content-renews');
    var renewLabelEl = renewBlockEl && renewBlockEl.querySelector('.membership-plus__content-label');
    var renewDateEl = document.querySelector('.membership_end_date');
    var renewalResolved = false;
    function resolveRenewal(label, date) {
        if (renewalResolved) return;
        if (renewLabelEl) renewLabelEl.innerHTML = label;
        if (renewDateEl) renewDateEl.innerHTML = date || '';
        if (renewBlockEl) renewBlockEl.style.visibility = 'visible';
        renewalResolved = true;
    }
    // Untagged resolves sync; tagged waits for API
    if (!hasMemberTag) resolveRenewal("Currently Inactive");

    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var myData = {
                    'ShopifyCustomerID': ShopifyCustomerId,
                    'CustomerEmail': CustomerEmail
                };
                var url = SEEndpointURL + 'api/customer/plusmembership?key=' + Math.random();
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(myData),
                    })
                    .then(
                        function(response) {
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with get membership information. Status Code: ' +
                                    response.status);
                                if (hasMemberTag) resolveRenewal("Currently Active");
                                return;
                            }
                            response.json().then(function(_data) {
                                console.log('Success');
                                if (_data != null) {
                                    var hasActiveRenewal = false;
                                    if(hasMemberTag && _data.Data.t_UnsubDate){
                                        var tmpDate = _data.Data.t_UnsubDate.split(' ');
                                        var monthUnsub = tmpDate[0];

                                        var obj = new Date(_data.Data.t_UnsubDate);
                                        if (_data.Data.s_status.toUpperCase() == "INACTIVE" || (obj.getTime() < new Date().getTime())) { // Cancelled review, or Inactive as well
                                            //document.querySelector('.membership-plus__content-renews').parentElement.style = "display:none;"
                                        }else{ //SWIMOUTLET-48951
                                            var appendFix = "th";
                                            var dayUnsub = obj.getDate();
                                            switch (dayUnsub){
                                                case (1):
                                                case (21):
                                                    appendFix = "st";
                                                    break;
                                                case (2):
                                                case (22):
                                                    appendFix = "nd";
                                                    break;
                                                case (3):
                                                case (23):
                                                    appendFix = "rd";
                                                    break;
                                            }
                                            //document.querySelector('.membership_end_date').innerHTML = _data.Data.t_UnsubDate;
                                            // SO-67943: render renewal copy + date
                                            resolveRenewal('Membership Renewal Will Occur on:', monthUnsub + " " + dayUnsub + appendFix + ", " + obj.getFullYear());
                                            hasActiveRenewal = true;
                                        }
                                    }
                                    // SO-67943: tag active but no valid renewal date from API
                                    if (hasMemberTag && !hasActiveRenewal) resolveRenewal("Currently Active");

                                    document.querySelector('.membership_status_label').innerHTML = _data.Data.s_Label;

                                    document.querySelector('.creditback_available').innerHTML = '$' + js_RoundNumber(_data.Data.MembershipReward.AvailableStoreCreditBack);
                                    document.querySelector('.creditback_pending').innerHTML = '$' + js_RoundNumber(_data.Data.MembershipReward.PendingStoreCreditBack);
                                    document.querySelector('.creditback_redeemed').innerHTML = '$' + js_RoundNumber(_data.Data.MembershipReward.RedeemedStoreCreditBack);
                                    document.querySelectorAll('.creditback_earned').forEach((el)=>{
                                        el.innerHTML = '$' + js_RoundNumber(_data.Data.MembershipReward.EarnedStoreCreditBack);
                                    })

                                    document.querySelector('.total_saving').innerHTML = '$' + js_RoundNumber(Math.abs(_data.Data.TotalSavinigsSinceJoining));
                                    if (_data.Data.PayPal_Status == "ACTIVE") {
                                        document.querySelector('.paypal_inquiry_popup').style = "display:inline;";
                                    } else {
                                        document.querySelector('.recharge_inquiry').style = "display:inline;";
                                    }

                                }

                            });
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                        if (hasMemberTag) resolveRenewal("Currently Active");
                    });

            } else if (hasMemberTag) {
                resolveRenewal("Currently Active");
            }

        }).catch(err => {
            console.log("Error when getting token key for membership information" + err);
            if (hasMemberTag) resolveRenewal("Currently Active");
        });

}

function changeSubscription() {
    document.getElementById("customer_orders").style.display = 'none';
    if (document.getElementById("admin_header") != null) document.getElementById("admin_header").style.display = 'none';
    document.getElementById("divChangeEmail").style.display = 'none';
    document.getElementById("divNewsletterSubscription").style.display = 'block';
}

function backToMyAccount() {
    document.getElementById("lblNotification").innerHTML = "";
    document.getElementById("chkKeepUpToDate").checked = document.getElementById("hidEmailSubscription").value === 'true';
    document.getElementById("newemail").value = "";
    document.getElementById("retypenewemail").value = "";

    document.getElementById("customer_orders").style.display = 'block';
    if (document.getElementById("admin_header") != null) document.getElementById("admin_header").style.display = 'block';
    document.getElementById("divNewsletterSubscription").style.display = 'none';
    document.getElementById("divChangeEmail").style.display = 'none';
    document.getElementById("lblEmailError").style.display = 'none';
    document.getElementById("lblEmailNotification").style.display = 'none';
    document.getElementById("lblEmailNotification").style.display = 'none';
    hideElement("#divPlusMembership");
}

function toggleChk() {
    var chkKeepUpToDate = document.getElementById("chkKeepUpToDate");
    if (chkKeepUpToDate.checked)
        chkKeepUpToDate.checked = false;
    else
        chkKeepUpToDate.checked = true;
}

function submitSubscription(event) {
    event.preventDefault();
    event.stopPropagation();
    document.getElementById("lblNotification").innerHTML = "";
    document.getElementById("divSubLoading").style.display = 'block';
    var chkKeepUpToDate = document.getElementById("chkKeepUpToDate");
    var isSub = false;
    if (chkKeepUpToDate.checked)
        isSub = true;

    var myData = {
        "FromSite": "SWIMOUTLET",
        "ShopifyCustomerID": ShopifyCustomerId,
        "ShopifyCustomerEmail": CustomerEmail,
        "CustomerSubscription": isSub
    };
    var url = SEEndpointURL + 'api/customer/subscription?key=' + Math.random();
    fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': Cookies.get('apikey'),
            },
            body: JSON.stringify(myData),
        })
        .then(
            function(response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem with submitSubscription(). Status Code: ' +
                        response.status);
                    return;
                }
                response.json().then(function(_data) {
                    document.getElementById("divSubLoading").style.display = 'none';
                    if (_data != null) {
                        document.getElementById("lblNotification").innerHTML = _data.Data;
                        document.getElementById("hidEmailSubscription").value = isSub;
                    } else
                        document.getElementById("lblNotification").innerHTML = "Your newsletter subscription was updated successfully!";
                });
            }
        )
        .catch(function(err) {
            console.log('Fetch Error :-S', err);
        });

}

function getGcByUser(custid, email) { // console.log('_cust:' + custid);

    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var myData = {
                    'newEmail': email,
                    'ShopifyCustomerID': custid,
                    'action': 'getGiftCard',
                    'fromSite': 'SWIMOUTLET'
                };
                var url = SEEndpointURL + 'api/product/giftcarduser?key=' + Math.random();
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                        },
                        body: JSON.stringify(myData),
                    })
                    .then(
                        function(response) {
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with getGcByUser(). Status Code: ' +
                                    response.status);
                                return;
                            }
                            response.json().then(function(_data) {
                                var gcleft = _data.Data.filter(function(d) {
                                    return d.GiftAmountLeft > 0;
                                });
                                if (gcleft.length > 0) {
                                    var amountleft = 0;
                                    for (var i = 0; i < gcleft.length; i++) {
                                        amountleft += parseFloat(gcleft[i].GiftAmountLeft);
                                        // console.log('amountleft:' + amountleft);
                                    }
                                    document.querySelector('.store-credit-balance').innerHTML = '$' + js_RoundNumber(amountleft);
                                }
                            });
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });

            }

        }).catch(err => {
            console.log("Error when getting API key of getGcByUser() in se-myaccount.js" + err);
        });

}

//SWIMOUTLET-50516-Create Storefront Account Switcher for Team Admins
var currentaccountlineitem = '' +
    '                            <div class="team-switcher-acc-profile">' +
    '                              <div class="acc-profile-thumb acc-profile-thumb-color personal-thumb">' +
    '                              <img src="https://cdn.shopify.com/s/files/1/0248/3024/6994/files/generic-team-avatar.svg?v=1656556096">' +
    '                              </div>' +
    '                            </div>' +
    '                            <div class="team-switcher-acc-name">' +
    '                              <div class="team-switcher-fullname">Swimmingly Swimming Swim Club</div>' +
    '                              <div class="team-switcher-link"><a href="#" class="ga4-tracking-button" data-label="switcher-account">Manage Your Team Account</a></div>' +
    '                            </div>' +
    '';
var notcurrentaccountlineitem = '' +
    '                              <div class="team-switcher-acc-profile">' +
    '                                <div class="acc-profile-thumb acc-profile-thumb-color personal-thumb">' +
    '                                   <svg class="icon icon--account" xmlns="http://www.w3.org/2000/svg" width="17.25" height="19.25" viewBox="0 0 17.25 19.25">' +
    '                                       <path id="Man" d="M8,18c-3.684,0-6.375-.8-8-2.369A6.784,6.784,0,0,1,4.706,9c.118.055.237.112.358.171A6.425,6.425,0,0,0,8,10a5.987,5.987,0,0,0,2.661-.72c.217-.1.422-.194.633-.28a7.206,7.206,0,0,1,3.389,2.468A6.944,6.944,0,0,1,16,15.631C14.375,17.2,11.684,18,8,18ZM8,8a4,4,0,1,1,4-4A4.005,4.005,0,0,1,8,8Z" transform="translate(0.625 0.625)" fill="none" stroke="currentColor" stroke-width="1.25"></path>' +
    '                                   </svg>' +
    '                                </div>' +
    '                              </div>' +
    '                              <div class="team-switcher-acc-name">' +
    '                                 <div class="team-switcher-fullname">Alexander Sienkiewicz</div>' +
    '                                 <div class="team-switcher-link" ><a href="#" class="ga4-tracking-button" data-label="switcher-account">Manage Your Account</a></div>' +
    '                              </div>' +
    '';
function getAccountList(custid) {
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {

                //SWIMOUTLET-52599-case login multipass with team account
                var accountType = "personalaccount";
                var shopifyCustomerId_personal = 0;
                var realReplogin = 'N';
                if (IsTeamAccount) {
                    accountType = "teamaccount";
                    if ((Cookies.get('repLogin') == 'true' || Cookies.get('repLoginAccountSwitcher') == 'true') && !Cookies.get("frm"))
                    {
                        realReplogin = 'Y';
                    }
                    else
                    {
                        //SO-70565-frm can be absent here too, and throwing took the switcher down along
                        //with the only Sign Out a Team Account has. Carry on with the personal id left
                        //at 0 and let the API resolve it from the team session.
                        try {
                            let frm_teamrole = JSON.parse(Cookies.get("frm"));
                            shopifyCustomerId_personal = frm_teamrole.i;
                        }
                        catch (e) { /* frm absent or unreadable */ }
                    }
                }

                //get list team account
                var myData = {
                    'ShopifyCustomerID': custid,
                    'ShopifyCustomerID_personal': shopifyCustomerId_personal,
                    'realReplogin': realReplogin,
                    'accountType': accountType
                };
                var url = SEEndpointURL + 'api/teamstore/accountswitcher/list?key=' + Math.random();
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apitoken': my_token,
                    },
                    body: JSON.stringify(myData),
                })
                    .then(
                        function (response) {
                            response.json().then(function (data) {
                                if (data.Data.items && data.Data.items.length > 0) {
                                    data.Data.items.forEach(function (p) {

                                        //current account login is team account type
                                        if (accountType == "teamaccount") {
                                            if (!p.teamid) {
                                                document.querySelectorAll("span.team-switcher-email-link").forEach(it => {
                                                    it.innerHTML = p.emailaddress;
                                                });
                                                //render personal account
                                                var parserPersonalLine = new DOMParser();
                                                var htmlPersonalAccountLine = parserPersonalLine.parseFromString(notcurrentaccountlineitem, 'text/html');
                                                //for ticket SWIMOUTLET-51232
                                                if (!p.teamfirstname && !p.teamlastname) {
                                                    htmlPersonalAccountLine.querySelector("div.team-switcher-fullname").innerHTML = "Personal Account";
                                                }
                                                {
                                                    htmlPersonalAccountLine.querySelector("div.team-switcher-fullname").innerHTML = p.teamfirstname + " " + p.teamlastname;
                                                }
                                                if(p.teamlogo !== "" && p.teamlogo !== null){
                                                    htmlPersonalAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                htmlPersonalAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "javascript:changeAccountWithMultipass('" + p.shopifycustomerid + "','personalaccount','');");
                                                if ((Cookies.get('repLogin') == 'true' || Cookies.get('repLoginAccountSwitcher') == 'true') && !Cookies.get("frm"))
                                                {
                                                    //SO-70565-match the session-length expiry used everywhere else frm is written
                                                    Cookies.set("frm", JSON.stringify({i: p.shopifycustomerid, r: 's'}), { expires: 30, path: '/', secure: true });
                                                }
                                                var HTMLAccountPersonallineItem = htmlPersonalAccountLine.body.innerHTML;
                                                var listPersonalAccountElement = document.querySelectorAll("div.acc-switcher-content-inner > div.team-switcher-row.team-switcher-acc");
                                                listPersonalAccountElement.forEach(itemPersonalAccountElement => {
                                                    var myDivItem = document.createElement("div");
                                                    myDivItem.className = 'team-switcher-acc-row';
                                                    myDivItem.innerHTML = HTMLAccountPersonallineItem;
                                                    itemPersonalAccountElement.appendChild(myDivItem);
                                                });
                                            }
                                            else if (p.shopifycustomerid == custid) {
                                                //Replace "Team Account" with the team name
                                                var listSwitcherTitleElement = document.querySelectorAll("span.acc-switcher-text");
                                                for (var i = 0; i < listSwitcherTitleElement.length; ++i) {
                                                    listSwitcherTitleElement[i].innerText = p.teamname;
                                                }
                                                syncTeamSwitcherToggleTooltip();

                                                if (p.teamstoreid) {
                                                    //set team store id to cookie
                                                    Cookies.set("teamstoreid_" + p.teamid, p.teamstoreid, { expires: 1, path: '/', secure: true });
                                                }

                                                //set cookie for current team account logged in
                                                if (p.teamstoreid) {
                                                    Cookies.set("storeid", p.teamstoreid, { expires: 1, path: '/', secure: true });
                                                }
                                                else {
                                                    Cookies.set("storeid", "0", { expires: 1, path: '/', secure: true });
                                                }
                                                Cookies.set("dashboard_teamid",  p.teamid, { expires: 1, path: '/', secure: true });

                                                //SWIMOUTLET-55903-Team Suits Survey - Get s_TeamFrontendID cookies when login
                                                if (p.teamfrontendid) {
                                                    Cookies.set("dashboard_teamfrontendid", p.teamfrontendid, { expires: 1, path: '/', secure: true });
                                                }
                                                else {
                                                    Cookies.set("dashboard_teamfrontendid", "0", { expires: 1, path: '/', secure: true });
                                                }

                                                //get logo team path
                                                var logoTeamPath = "";
                                                if (p.teamlogo) {
                                                    logoTeamPath = photoURL + "photos/Affiliate_StoreFront/" + p.teamlogo;
                                                }

                                                //render team account as current login team account
                                                var parserTeamlLine = new DOMParser();
                                                var htmlTeamAccountLine = parserTeamlLine.parseFromString(currentaccountlineitem, 'text/html');
                                                htmlTeamAccountLine.querySelector("div.team-switcher-fullname").innerHTML = p.teamname;
                                                htmlTeamAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "/account?view=team-dashboard");
                                                if (logoTeamPath) {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", logoTeamPath);
                                                    document.querySelector("span.acc-switcher-icon > img").setAttribute("src", logoTeamPath);
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }else {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", "https://cdn.shopify.com/s/files/1/0248/3024/6994/files/generic-team-avatar.svg?v=1656556096");
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                var HTMLTeamAccountlineItem = htmlTeamAccountLine.body.innerHTML;
                                                var listTeamAccountElement = document.querySelectorAll("div.acc-switcher-content-inner");
                                                listTeamAccountElement.forEach(itemTeamAccountElement => {
                                                    var myDivItem = document.createElement("div");
                                                    myDivItem.classList.add('team-switcher-row');
                                                    myDivItem.classList.add('team-switcher-manage');
                                                    myDivItem.innerHTML = HTMLTeamAccountlineItem;
                                                    itemTeamAccountElement.appendChild(myDivItem);
                                                    itemTeamAccountElement.insertBefore(myDivItem, itemTeamAccountElement.children[0]);
                                                });
                                            }
                                            else {
                                                if (p.teamstoreid) {
                                                    //set team store id to cookie
                                                    Cookies.set("teamstoreid_" + p.teamid, p.teamstoreid, { expires: 1, path: '/', secure: true });
                                                }

                                                //get logo team path
                                                var logoTeamPath = "";
                                                if (p.teamlogo) {
                                                    logoTeamPath = photoURL + "photos/Affiliate_StoreFront/" + p.teamlogo;
                                                }

                                                //render team account as not current login team account
                                                var parserTeamlLine = new DOMParser();
                                                var accountTeamType = "teamaccount";
                                                var htmlTeamAccountLine = parserTeamlLine.parseFromString(notcurrentaccountlineitem, 'text/html');
                                                htmlTeamAccountLine.querySelector("div.acc-profile-thumb > svg").remove();
                                                //append img tag
                                                var imgTag = document.createElement("img");
                                                htmlTeamAccountLine.querySelector("div.acc-profile-thumb").appendChild(imgTag);
                                                if (logoTeamPath) {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", logoTeamPath);
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                else {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", "https://cdn.shopify.com/s/files/1/0248/3024/6994/files/generic-team-avatar.svg?v=1656556096");
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                htmlTeamAccountLine.querySelector("div.team-switcher-fullname").innerHTML = p.teamname;
                                                htmlTeamAccountLine.querySelector("div.team-switcher-link > a").innerHTML = "Manage Your Team Account";
                                                htmlTeamAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "javascript:changeAccountWithMultipass('" + p.teamid + "','teamaccount','" + (p.teamRole == "Super Admin" ? "s" : "a") + "');");
                                                var HTMLTeamAccountlineItem = htmlTeamAccountLine.body.innerHTML;
                                                var listTeamAccountElement = document.querySelectorAll("div.acc-switcher-content-inner > div.team-switcher-row.team-switcher-acc");
                                                listTeamAccountElement.forEach(itemTeamAccountElement => {
                                                    var myDivItem = document.createElement("div");
                                                    myDivItem.className = 'team-switcher-acc-row';
                                                    myDivItem.innerHTML = HTMLTeamAccountlineItem;
                                                    itemTeamAccountElement.appendChild(myDivItem);
                                                });
                                            }
                                        }
                                        else {
                                            document.querySelectorAll('div.account-team-sidebar-wrapper').forEach(function (val) { val.classList.remove('d-none'); });
                                            if (!p.teamid) {
                                                document.querySelectorAll("span.team-switcher-email-link").forEach(it => {
                                                    it.innerHTML = p.emailaddress;
                                                });
                                                //render personal account
                                                var parserPersonalLine = new DOMParser();
                                                var htmlPersonalAccountLine = parserPersonalLine.parseFromString(currentaccountlineitem, 'text/html');
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > img").remove();
                                                //append svg tag
                                                var svgTag = document.createElement("svg");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb").appendChild(svgTag);
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").setAttribute("class", "icon icon--account");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").setAttribute("xmlns", "http://www.w3.org/2000/svg");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").setAttribute("width", "17.25");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").setAttribute("height", "19.25");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").setAttribute("viewBox", "0 0 17.25 19.25");
                                                //append path tag
                                                var pathTag = document.createElement("path");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg").appendChild(pathTag);
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("id", "Man");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("d", "M8,18c-3.684,0-6.375-.8-8-2.369A6.784,6.784,0,0,1,4.706,9c.118.055.237.112.358.171A6.425,6.425,0,0,0,8,10a5.987,5.987,0,0,0,2.661-.72c.217-.1.422-.194.633-.28a7.206,7.206,0,0,1,3.389,2.468A6.944,6.944,0,0,1,16,15.631C14.375,17.2,11.684,18,8,18ZM8,8a4,4,0,1,1,4-4A4.005,4.005,0,0,1,8,8Z");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("transform", "translate(0.625 0.625)");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("fill", "none");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("stroke", "currentColor");
                                                htmlPersonalAccountLine.querySelector("div.acc-profile-thumb > svg > path").setAttribute("stroke-width", "1.25");
                                                if(p.teamlogo !== "" && p.teamlogo !== null){
                                                    htmlPersonalAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                //for ticket SWIMOUTLET-51232
                                                if (!ShopifyCustomerName && !ShopifyCustomerLastName) {
                                                    htmlPersonalAccountLine.querySelector("div.team-switcher-fullname").innerHTML = "Personal Account";
                                                }
                                                else {
                                                    htmlPersonalAccountLine.querySelector("div.team-switcher-fullname").innerHTML = ShopifyCustomerName + " " + ShopifyCustomerLastName;
                                                }
                                                htmlPersonalAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "/account");
                                                htmlPersonalAccountLine.querySelector("div.team-switcher-link > a").innerHTML = "Manage Your Account";
                                                var HTMLAccountPersonallineItem = htmlPersonalAccountLine.body.innerHTML;
                                                var listPersonalAccountElement = document.querySelectorAll("div.acc-switcher-content-inner");
                                                listPersonalAccountElement.forEach(itemPersonalAccountElement => {
                                                    var myDivItem = document.createElement("div");
                                                    myDivItem.classList.add('team-switcher-row');
                                                    myDivItem.classList.add('team-switcher-manage');
                                                    myDivItem.innerHTML = HTMLAccountPersonallineItem;
                                                    itemPersonalAccountElement.appendChild(myDivItem);
                                                    itemPersonalAccountElement.insertBefore(myDivItem, itemPersonalAccountElement.children[0]);
                                                });
                                            }
                                            else {
                                                if (p.teamstoreid) {
                                                    //set team store id to cookie
                                                    Cookies.set("teamstoreid_" + p.teamid, p.teamstoreid, { expires: 1, path: '/', secure: true });
                                                }

                                                //get logo team path
                                                var logoTeamPath = "";
                                                if (p.teamlogo) {
                                                    logoTeamPath = photoURL + "photos/Affiliate_StoreFront/" + p.teamlogo;
                                                }

                                                //render team account as not current login team account
                                                var parserTeamlLine = new DOMParser();
                                                var htmlTeamAccountLine = parserTeamlLine.parseFromString(notcurrentaccountlineitem, 'text/html');
                                                htmlTeamAccountLine.querySelector("div.acc-profile-thumb > svg").remove();
                                                //append img tag
                                                var imgTag = document.createElement("img");
                                                htmlTeamAccountLine.querySelector("div.acc-profile-thumb").appendChild(imgTag);
                                                if (logoTeamPath) {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", logoTeamPath);
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                else {
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb > img").setAttribute("src", "https://cdn.shopify.com/s/files/1/0248/3024/6994/files/generic-team-avatar.svg?v=1656556096");
                                                    htmlTeamAccountLine.querySelector("div.acc-profile-thumb").classList.remove("personal-thumb")
                                                }
                                                htmlTeamAccountLine.querySelector("div.team-switcher-fullname").innerHTML = p.teamname;
                                                htmlTeamAccountLine.querySelector("div.team-switcher-link > a").innerHTML = "Manage Your Team Account";
                                                htmlTeamAccountLine.querySelector("div.team-switcher-link > a").setAttribute("href", "javascript:changeAccountWithMultipass('" + p.teamid + "','teamaccount','" + (p.teamRole == "Super Admin" ? "s" : "a") + "');");
                                                var HTMLTeamAccountlineItem = htmlTeamAccountLine.body.innerHTML;
                                                var listTeamAccountElement = document.querySelectorAll("div.acc-switcher-content-inner > div.team-switcher-row.team-switcher-acc");
                                                listTeamAccountElement.forEach(itemTeamAccountElement => {
                                                    var myDivItem = document.createElement("div");
                                                    myDivItem.className = 'team-switcher-acc-row';
                                                    myDivItem.innerHTML = HTMLTeamAccountlineItem;
                                                    itemTeamAccountElement.appendChild(myDivItem);
                                                });
                                            }
                                        }
                                    });
                                }
                                else {
                                    //update account-team-sidebar-wrapper class
                                    document.querySelectorAll('div.account-team-sidebar-wrapper').forEach(function (val) {
                                        if (val && val.parentNode) {
                                            val.parentNode.removeChild(val);
                                        }
                                    });
                                }
                            });
                        }
                    )
                    .catch(function (err) {
                        //update account-team-sidebar-wrapper class
                        document.querySelectorAll('div.account-team-sidebar-wrapper').forEach(function (val) {
                            if (val && val.parentNode) {
                                val.parentNode.removeChild(val);
                            }
                        });
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            //update account-team-sidebar-wrapper class
            document.querySelectorAll('div.account-team-sidebar-wrapper').forEach(function (val) {
                if (val && val.parentNode) {
                    val.parentNode.removeChild(val);
                }
            });
            console.log("Error when getting API key of getAccountList() in se-myaccount.js" + err);
        });
}

function changeAccountWithMultipass(accountID, accountType, accountRole) {
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                showElement('.so-loading');
                lockscreen("", 0);
                Cookies.remove('rewards', { path: '/' }); //SWIMOUTLET-53583
                if (accountType == "personalaccount") {
                    //remove cookies dashboard_teamid
                    Cookies.remove('dashboard_teamid', { path: '/' });
                    //remove cookies storeid
                    Cookies.remove('storeid', { path: '/' });
                    //remove cookies dashboard_teamfrontendid
                    Cookies.remove('dashboard_teamfrontendid', { path: '/' });
                    //remove cookies frm for ticket SWIMOUTLET-60656
                    Cookies.remove('frm', { path: '/' });
                }
                if (accountType == "teamaccount") {
                    var current_store_id = "";
                    //set team store id to cookie
                    current_store_id = Cookies.get("teamstoreid_" + accountID);
                    if (current_store_id) {
                        Cookies.set("storeid", current_store_id, { expires: 1, path: '/', secure: true });
                    }
                    else {
                        Cookies.set("storeid", "0", { expires: 1, path: '/', secure: true });
                    }
                    Cookies.set("dashboard_teamid", accountID, { expires: 1, path: '/', secure: true });
                    //set cookie frm for ticket SWIMOUTLET-60656
                    //SO-70565-nothing refreshes frm on page load, so this expiry is a hard deadline from the last switch
                    if (!Cookies.get("frm")) {
                        Cookies.set("frm", JSON.stringify({i: ShopifyCustomerId, r: accountRole}), { expires: 30, path: '/', secure: true });
                    }
                    else
                    {
                        Cookies.set("frm", JSON.stringify({i: JSON.parse(Cookies.get("frm")).i, r: accountRole}), { expires: 30, path: '/', secure: true });
                    }
                }
                //check for SWIMOUTLET-59294
                var realReplogin = 'N';
                if (Cookies.get('repLogin') == 'true')
                {
                    realReplogin = 'Y';
                }
                var shopifyCustomerId_personal = 0;
                if (accountType == "teamaccount") {
                    shopifyCustomerId_personal = JSON.parse(Cookies.get("frm")).i;
                }

                var myData = {
                    'accountID': accountID,
                    'accountType': accountType,
                    'return_to': accountType == "teamaccount" ? origin + "/account?view=team-dashboard" : origin + "/account",
                    'realReplogin': realReplogin,
                    'shopifyCustomerId': ShopifyCustomerId,
                    'shopifyCustomerId_personal': shopifyCustomerId_personal
                };
                var url = SEEndpointURL + 'api/customer/multipass/storefrontaccountswitcher?key=' + Math.random();
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apitoken': my_token
                    },
                    body: JSON.stringify(myData),
                })
                    .then(
                        function (response) {
                            response.json().then(function (data) {
                                if (data.Data) {
                                    var origin = window.location.origin; //for staging
                                    //var origin = 'https://swimoutlet.com';

                                    //var win = window.open(origin + "/account/logout/", 'sign out', 'width=1,height=1,left=5,top=3'); // Log out to reset cookie
                                    //setTimeout(function () { win.close(); }, 2000); // wait 2s to clean all cookie before closeout
                                    var _uri = origin + "/account/login/multipass/" + data.Data;
                                    setTimeout(function () {
                                        window.location.href = _uri;
                                        if (accountType == "teamaccount") {
                                            Cookies.set("isRedirectToTeamDashBoardPage", "loaded", { expires: 1, path: '/', secure: true });
                                        }
                                    }, 2500);
                                }
                            });
                        }
                    )
                    .catch(function (err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of changeAccountWithMultipass() in se-myaccount.js" + err);
        });
}

function redeemGC() {
    if (Cookies.get('apitoken') != null) {
        if (ShopifyCustomerId > 0) {
            var c1 = document.querySelector('[data-credit="first"]').value.trim();
            var c2 = document.querySelector('[data-credit="second"]').value.trim();
            var c3 = document.querySelector('[data-credit="third"]').value.trim();
            var GiftCardCode = (c1 + c2 + c3).replace(/-/g, "");
            if (GiftCardCode.length >= 10) {
                var myData = {
                    'shopifyEmail': CustomerEmail,
                    'shopifyCustId': ShopifyCustomerId,
                    'GiftCardCode': window.btoa(GiftCardCode),
                    'action': 'redeemGiftCard',
                    'fromSite': 'SWIMOUTLET'
                };
                var url = SEEndpointURL + 'api/product/redeemgiftcard?key=' + Math.random();

                var request = new XMLHttpRequest();
                request.open('POST', url, true);
                request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
                request.setRequestHeader('apitoken', Cookies.get('apitoken'));
                request.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success!
                        var resp = this.response;
                        console.log('Success');
                        if (resp != null) {
                            var response = JSON.parse(resp);
                            if (response.Meta.message == "not_found")
                                alert("Please enter a valid gift card");
                            else if (response.Meta.message == "already")
                                alert("This gift card has already been applied to your account");
                            else {
                                getGcByUser(ShopifyCustomerId, CustomerEmail);
                                input_code();
                            }
                        }
                    } else {
                        // We reached our target server, but it returned an error
                        console.log(' We reached our target server, but it returned an error');

                    }
                };
                request.onerror = function(error) {
                    // There was a connection error of some sort
                    console.log('There was a connection error of some sort');
                };
                request.send(JSON.stringify(myData));
            }
        }
    } else {
        console.log('token is null, can not verify this account');
    }
}

function input_code() {
    document.querySelector('[data-credit="new-giftcard"]').classList.toggle('d-inline-block');
    document.querySelector('input[data-credit]').value = ''; // reset
    document.querySelector('[data-credit="show-input"]').classList.toggle('Button--primary--Active');
}


function getSubscriptionDetail(email, custRequestToken, custRequestId) {
    if (!document.getElementById("divSubscriptiosStatus")) return false;

    getApiToken()
        .then(my_token => {
            if (my_token != "") {
                var myData = {
                    "ShopifyCustomerEmail": email,
                    "ListID": custRequestId,
                    "Token": custRequestToken
                };
                var url = SEEndpointURL + 'api/customer/getsubscription?key=' + Math.random();
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apikey': my_token,
                        },
                        body: JSON.stringify(myData),
                    })
                    .then(
                        function(response) {
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with getSubscriptionDetail(). Status Code: ' +
                                    response.status);
                                return;
                            }
                            response.json().then(function(_data) {
                                if (Array.isArray(_data.Data)) {
                                    _data.Data.forEach((item) => {
                                        if (item.CustomerSubscription == false) {
                                            document.getElementById("divSubscriptiosStatus").innerHTML = "You are currently unsubscribed from all lists.";
                                            return false;
                                        }
                                    })
                                } else if (_data.Data.CustomerSubscription == false)
                                    document.getElementById("divSubscriptiosStatus").innerHTML = "You are currently unsubscribed from all lists.";
                            });
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of getSubscriptionDetail() in se-myaccount.js" + err);
        });
}

function getParameterByName(name, url = window.location.href) { // Get querystring
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

//Paypal inquiry area
function validatePaypalFields() {
    var isValidForm = true;
    if (document.querySelector(".account-fullname").value) {
        document.querySelector(".account-fullname").classList.remove("is-invalid");
    } else {
        document.querySelector(".account-fullname").classList.add("is-invalid");
        isValidForm = false;
    }

    if (document.querySelector(".account-state").value) {
        document.querySelector(".account-state").classList.remove("is-invalid");
    } else {
        document.querySelector(".account-state").classList.add("is-invalid");
        isValidForm = false;
    }

    if (document.querySelector(".account-email").value) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
        if (!regex.test(document.querySelector(".account-email").value)) {
            document.querySelector(".account-email").classList.add("is-invalid");
            isValidForm = false;
        } else {
            document.querySelector(".account-email").classList.remove("is-invalid");
        }
    } else {
        document.querySelector(".account-email").classList.add("is-invalid");
        isValidForm = false;
    }

    if (document.querySelector(".account-comment").value) {
        document.querySelector(".account-comment").classList.remove("is-invalid");
    } else {
        document.querySelector(".account-comment").classList.add("is-invalid");
        isValidForm = false;
    }
    return isValidForm;
}

function sendPayPalInquiry() {
    if (validatePaypalFields()) {
        document.querySelector(".btn-paypal-inquiry").setAttribute("disabled", true);
        document.querySelector(".btn-paypal-inquiry").textContent = 'Submitting...';
        getLoginApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var myData = {
                        'ShopifyCustomerID': ShopifyCustomerId,
                        "PayPalCustomerEmail": document.querySelector(".account-email").value,
                        "ShopifyFullName": document.querySelector(".account-fullname").value,
                        "AddressState": document.querySelector(".account-state").value,
                        "Comment": document.querySelector(".account-comment").value,
                        "ContactPhone": (document.querySelector("#contactphone:checked")) ? 'Yes' : 'No',
                        "ContactEmail": (document.querySelector("#contactemail:checked")) ? 'Yes' : 'No'
                    };
                    var url = SEEndpointURL + 'api/customer/paypalinquiry?key=' + Math.random();
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token,
                                'skey': ShopifyCustomerKey
                            },
                            body: JSON.stringify(myData),
                        })
                        .then(
                            function(response) {
                                if (response.status !== 200) {
                                    console.log('Looks like there was a problem with getPaypalInquiry. Status Code: ' +
                                        response.status);
                                    alert('Oops!Something went wrong' + response.status);
                                    return;
                                }
                                response.json().then(function(_data) {
                                    showElement('.alert-success');
                                });
                            }
                        )
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });

                }

            }).catch(err => {
                console.log("Error when getting API key of sendPayPaylInquiry" + err);
            });
    } else {
        console.log("PayPal inquiry fields are not valid");
    }

}
//end Paypal

var orderlist = '' +
    '	<div class="account-block__row">' +
    '	  <div class="account-block__col account-block--order">' +
    '		<div class="order-date">Mar 11, 2021</div>' +
    '		<div class="order-status">Unfulfilled</div>' +
    '		<div class="order-id"><span class="order__label">Order#:</span><span class="order__value"><a href="https://alpha.swimoutlet.com/account/orders/e9909795930db41ff69270b1b8216031" title="">SO5552694</a></span></div>' +
    '		<div class="order-qty"><span class="order__label">Order Qty:</span><span class="order__value">14</span></div>' +
    '		<div class="order-total"><span class="order__label">Order Total:</span><span class="order__value">$45.72</span></div>' +
    '	  </div>' +
    '	  <div class="account-block__col">' +
    '		<div class="account-list-group">' +
    '		  <a href="https://alpha.swimoutlet.com/account/orders/e9909795930db41ff69270b1b8216031" class="account-list-group-item account-list-group-item--details">Order Details</a>' +
    '		  <a href="https://alpha.swimoutlet.com/account/orders/e9909795930db41ff69270b1b8216031?view=invoice" class="account-list-group-item account-list-group-item--invoice" target="_blank">Print Invoice</a>' +
    '		</div>' +
    '	  </div>' +
    '	</div>' +
    '	<!-- order product list -->' +
    '	' +
    '	<div class="order-product expanded">' +
    '		<div class="order-product-inner">' +

    '		</div>' +
    /* '		<span class="order-product-more">'+
    '		  <span>View More</span>'+
    '		  <span class="circle-icon center">'+
    '			<svg class="icon icon--arrow-bottom" role="presentation" viewBox="0 0 21 11">'+
    '			  <polyline fill="none" stroke="currentColor" points="0.5 0.5 10.5 10.5 20.5 0.5" stroke-width="1.25"></polyline>'+
    '			</svg>'+
    '		  </span>'+
    '		</span>'+ */
    '	</div>' +
    '	<!-- end order product list -->' +
    '';

var orderlineitem = '' +
    '                          <div class="order-product__col order-product-img">' +
    '                            <a href="/">' +
    '                              <img alt="Sporti Latex Swim Cap" class="img-lazyload" width="80" data-src="//cdn.shopify.com/s/files/1/0278/5522/4932/products/4767348785252-orange-1a_120x.jpg?v=1590589453" src="//cdn.shopify.com/s/files/1/0278/5522/4932/products/4767348785252-orange-1a_120x.jpg?v=1590589453">' +
    '                            </a>' +
    '                          </div>' +
    '                          <div class="order-product__col order-product-info">' +
    '                            <h3 class="order-product__title">' +
    //'                               <a href="/collections/Sporti" title="Sporti" class="order-product__brand-name">Sporti</a>'+
    '                               <a href="/" class="order-product__url" title="Sporti Latex Swim Cap Orange">Sporti Latex Swim Cap Orange</a>' +
    '                            </h3>' +
    '                            <div class="order-product__option">Orange</div>' +
    '                            <div class="order-product__quantity">Quantity: 1</div>' +
    '                            <div class="order-product__status order-product__status--shipped align-items-center mt-2" style="display: none;">' +
    '                              <div class="order-product__status-icon pr-2">' +
    '                                <img src="https://cdn.shopify.com/s/files/1/0248/3024/6994/files/so_icon_order_shipped.svg?v=1753779938" width="20">' +
    '                              </div>' +
    '                              <div class="order-product__status-text font-weight-bold text-succes" style="color: #55B948;">Item Shipped</div>' +
    '                            </div>' +
    '                            <div class="order-product__status order-product__status--pending align-items-center mt-2" style="display: none;">' +
    '                              <div class="order-product__status-icon pr-2">' +
    '                                <img src="https://cdn.shopify.com/s/files/1/0248/3024/6994/files/so_icon_order_pendding.svg?v=1753779938" width="20">' +
    '                              </div>' +
    '                              <div class="order-product__status-text font-weight-bold text-succes" style="color: gray;">Item Pending <span style="font-weight: 500 !important;"></span></div>' +
    '                            </div>' +
    '                          </div>' +
    '';

var paginationitem =
    '       <li class="page-item">' +
    '			<a class="page-link" href="#">1</a>' +
    '		</li>';

function getOrderList() {
    if (!ShopifyCustomerId > 0) return false;

    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                document.querySelectorAll(".account-block").forEach((orderEl) => {
                    orderEl.parentNode.removeChild(orderEl);
                });
                
                if(document.querySelector('.pagination-orders'))
                {
                    document.querySelector('.pagination-orders').innerHTML = ""; // Refresh paging
                }
                
                showElement('.so-loading');

                var SearchQuery = getParameterByName("q");
                var RecentMonths = getParameterByName("lastmonths");

                if (SearchQuery != null && SearchQuery.length > 0) {
                document.getElementsByName('SearchOrders')[0].value = SearchQuery;
                }

                if (RecentMonths != null && RecentMonths.length > 0) {
                    RecentMonths = parseInt(RecentMonths, 10);
                    if (isNaN(RecentMonths)) {
                        // If parsing fails => fallback to -1
                        RecentMonths = -2;
                    }

                    switch (RecentMonths) {
                        case 3:
                        case 6:
                        document.querySelector(".timeframe-btn span").textContent =
                            "last " + RecentMonths + " months";
                        break;

                        case 0:
                        case 12:
                        case 24:
                        case 36: {
                        var currentY = new Date();
                        var lastY = new Date(currentY.setMonth(currentY.getMonth() - RecentMonths));
                        document.querySelector(".timeframe-btn span").textContent = lastY.getFullYear();
                        break;
                        }

                        case -1:
                        document.querySelector(".timeframe-btn span").textContent = "last 12 months";
                        break;

                        default:
                        // Default all time
                        RecentMonths = -2;
                        document.querySelector(".timeframe-btn span").textContent = "all time";
                        break;
                    }
                } else {
                    // No param => default all time
                    RecentMonths = -2;
                    document.querySelector(".timeframe-btn span").textContent = "all time";
                }

                var myData = {
                    "l_ShopifyCustomerId": ShopifyCustomerId,
                    "i_ShopifySECustomerId": ShopifySECustomerId,
                    "s_SearchQuery": document.getElementsByName('SearchOrders')[0].value,
                    "i_RecentMonths": RecentMonths,
                    "i_PageIndex": getParameterByName("page")
                };
                var url = SEEndpointURL + 'api/order/search_order?key=' + Math.random();
                
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token, //getCookie('apitoken'),//Cookies.get('apitoken'),
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(myData),
                    })
                    .then(
                        function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with getOrderList(). Status Code: ' +
                                    response.status);
                                return;
                            }

                            response.json().then(function(_data) {
                                var listOrders = JSON.parse(_data.Data);
                                if (myData.l_ShopifyCustomerId === 3958270361768) {
                                    listOrders = listOrders.filter(order => order.source_name !== "pos");
                                }
                                if (listOrders.length > 0) {
                                    hideElement('.noorder');
                                    listOrders.forEach((order) => {
                                        var parser = new DOMParser();
                                        var htmlDoc = parser.parseFromString(orderlist, 'text/html');

                                        var order_created_at = new Date(order.created_at);
                                        var order_processed_at = new Date(order.processed_at);
                                        if (order_processed_at > order_created_at) {
                                            htmlDoc.querySelector('.order-date').textContent = order_created_at.toDateString(); //
                                        } else {
                                            htmlDoc.querySelector('.order-date').textContent = order_processed_at.toDateString(); //
                                        }
                                        if (order.cancel_reason || order.financial_status=='voided') {
                                            htmlDoc.querySelector('.order-status').textContent = "Cancelled";
                                        } else {
                                            htmlDoc.querySelector('.order-status').textContent = (order.fulfillment_status) ? order.fulfillment_status.replace("fulfilled", "Shipped").replace("partial", "Partially Shipped") : 'Pending Shipment'; // Order fulfilment
                                        }
                                        htmlDoc.querySelector('.order-id a').setAttribute("href", "https://" + config_domain + "/account/orders/" + order.token); // Order  link
                                        htmlDoc.querySelector('.order-id a').textContent = order.name; // Order name
                                        htmlDoc.querySelector('.account-list-group-item--details').setAttribute("href", "https://" + config_domain + "/account/orders/" + order.token); // Order Details link
                                        htmlDoc.querySelector('.account-list-group-item--invoice').setAttribute("href", "https://" + config_domain + "/account/orders/" + order.token + "?view=invoice"); // Print Invoice link
                                        htmlDoc.querySelector('.order-total .order__value').textContent = "$" + js_RoundNumber(order.total_price); // Order total price
                                        if (order.financial_status.indexOf("refunded") > 0) { // Adjust order total, adjust line item quantity and line total price
                                            var refund_trans = order.refunds[0].transactions;
                                            var totalRefund = 0;
                                            refund_trans.forEach((trans) => { //refund detail
                                                totalRefund += trans.amount;
                                            });
                                            htmlDoc.querySelector('.order-total .order__value').textContent = "$" + js_RoundNumber(order.total_price - totalRefund); // Order total price after minus refund
                                        }
                                        if (order.line_items.length == 1) {
                                            //htmlDoc.querySelector('.order-product-more').parentNode.removeChild(htmlDoc.querySelector('.order-product-more'));
                                        }



                                        // When you done this will return as string again
                                        var HTMLnewdata = htmlDoc.body.innerHTML;
                                        var myDiv = document.createElement("div");
                                        myDiv.className = 'account-block ' + order.name;
                                        myDiv.innerHTML = HTMLnewdata;
                                        var pagination_elem = document.querySelector(".pagination-orders");
                                        pagination_elem.parentNode.insertBefore(myDiv, pagination_elem);

                                        var lineItems = order.line_items;
                                        var qty = 0;
                                        var isCustomOrder = false; //SWIMOUTLET-46773
                                        lineItems.forEach((line) => { // order detail
                                            var is_Custom_LineId = false;
                                            //qty = qty + line.quantity;
                                            var parserLine = new DOMParser();
                                            var htmlLine = parserLine.parseFromString(orderlineitem, 'text/html');

                                            //var orderlineitem_handle = "/products/" +

                                            var propertyImg = line.properties.filter(function(x) { return x.name == 'product-image'; })
                                            if (propertyImg != null && propertyImg.length > 0) {
                                                htmlLine.querySelector(".order-product-img img").src = propertyImg[0].value; // Image product
                                                htmlLine.querySelector(".order-product-img img").setAttribute("data-src", propertyImg[0].value); // Image product
                                                htmlLine.querySelector(".order-product-img img").setAttribute("alt", line.name); // Product Name
                                                // customization image SWIMOUTLET-46773
                                                var customizationImg = line.properties.filter(function(x) { return x.name == 'TeamStore_Photo'; })
                                                if (customizationImg != null && customizationImg.length > 0) {
                                                    //fix broken customization products images SWIMOUTLET-53429
                                                    const isValidUrl = urlString=> {
                                                        var urlPattern = new RegExp('^(https?:\\/\\/)?'+ // validate protocol
                                                        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // validate domain name
                                                        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // validate OR ip (v4) address
                                                        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // validate port and path
                                                        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // validate query string
                                                        '(\\#[-a-z\\d_]*)?$','i'); // validate fragment locator
                                                        return !!urlPattern.test(urlString);
                                                    }

                                                    if(!isValidUrl(customizationImg[0].value)){
                                                        htmlLine.querySelector(".order-product-img img").setAttribute("data-src", propertyImg[0].value);
                                                        htmlLine.querySelector(".order-product-img img").src =  propertyImg[0].value

                                                        // let masterlinkString = line.properties.filter(function(x) { return x.name == 'masterlink'; })[0].value
                                                        // const hyphenIndex = masterlinkString.lastIndexOf("-");
                                                        // let masterNumber = masterlinkString.substring(hyphenIndex + 1);

                                                        // htmlLine.querySelector(".order-product-img img").src = "https://outlet.com/photos/Customization/"
                                                        //     + line.properties.filter(function(x) { return x.name == 'TeamStore_AffiliateId'; })[0].value + "/"
                                                        //     + masterNumber + "-custom-"
                                                        //     + line.properties.filter(function(x) { return x.name == 'TeamStore_CustomizationId'; })[0].value
                                                        //     + "-1.png";
                                                    }
                                                    else {
                                                        htmlLine.querySelector(".order-product-img img").src = customizationImg[0].value; // Image product
                                                    }
                                                }
                                            } else
                                                htmlLine.querySelector(".order-product-img img").src = '//cdn.shopify.com/shopifycloud/shopify/assets/no-image-160-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac_120x.gif'; // No photo

                                            var propertyHandle = line.properties.filter(function(x) { return x.name == 'handle'; })
                                            if (propertyHandle != null && propertyHandle.length > 0) {
                                                var link = "https://" + config_domain + "/products/" + propertyHandle[0].value;
                                                if (line.variant_id != null) {
                                                    link += "?variant=" + line.variant_id;
                                                }

                                                htmlLine.querySelector('.order-product-img a').setAttribute("href", link); // product  link
                                                htmlLine.querySelector('.order-product__url').setAttribute("href", link); // product  link

                                                var masterlink = line.properties.filter(function(x) { return x.name == 'masterlink'; }); //Customization link SWIMOUTLET-46773
                                                var TeamStore_StoreId = line.properties.filter(function(x) { return x.name == 'TeamStore_StoreId' || x.name == '_TeamStore_StoreId'; });
                                                var TeamStore_CustomizationId = line.properties.filter(function(x) { return x.name == 'TeamStore_CustomizationId' || x.name == '_TeamStore_CustomizationId'; });
                                                console.log("propertyHandle:" , propertyHandle);
                                                var Custom_LineId = line.properties.filter(function(x) { return x.name == 'Custom_LineId' || x.name == '_Custom_LineId' || x.name == 'TeamStore_LineId' || x.name == '_TeamStore_LineId' });
                                                if (Custom_LineId  != null && Custom_LineId.length > 0){
                                                    is_Custom_LineId = true;
                                                }
                                                console.log("masterlink:" , masterlink);
                                                if ((masterlink  != null && masterlink.length > 0) && (TeamStore_StoreId  != null && TeamStore_StoreId.length > 0) &&  (TeamStore_CustomizationId  != null && TeamStore_CustomizationId.length > 0)){
                                                    htmlLine.querySelector('.order-product-img a').setAttribute("href", "/products/" + masterlink[0].value + "?storeid="+TeamStore_StoreId[0].value + "&custom="+TeamStore_CustomizationId[0].value);
                                                    htmlLine.querySelector('.order-product__url').setAttribute("href", "/products/" + masterlink[0].value + "?storeid="+TeamStore_StoreId[0].value + "&custom="+TeamStore_CustomizationId[0].value);
                                                }
                                                else if (propertyHandle.length > 0 && (TeamStore_StoreId  != null && TeamStore_StoreId.length > 0) &&  (TeamStore_CustomizationId  != null && TeamStore_CustomizationId.length > 0)){
                                                    var p_handle = getProductURL(propertyHandle[0].value);
                                                    htmlLine.querySelector('.order-product-img a').setAttribute("href", "/products/" + p_handle + "?storeid="+TeamStore_StoreId[0].value + "&custom="+TeamStore_CustomizationId[0].value);
                                                    htmlLine.querySelector('.order-product__url').setAttribute("href", "/products/" + p_handle + "?storeid="+TeamStore_StoreId[0].value + "&custom="+TeamStore_CustomizationId[0].value);
                                                }
                                            }

                                            if(!is_Custom_LineId) qty = qty + line.quantity;

                                            // htmlLine.querySelector('.order-product__brand-name').setAttribute("href", "https://" + config_domain + "/collections/" + line.vendor.toLowerCase());  // Brand link
                                            // htmlLine.querySelector('.order-product__brand-name').setAttribute("title", line.vendor);  // Brand name
                                            // htmlLine.querySelector('.order-product__brand-name').textContent = line.vendor;  // Product name

                                            htmlLine.querySelector('.order-product__url').setAttribute("title", line.name); // Product name
                                            htmlLine.querySelector('.order-product__url').textContent = line.name; // Product name


                                            if (line.properties != null && line.properties.length > 0) { 
                                                var custom_options_html = "";
                                                line.properties.forEach((lineProperty) => {
                                                    // Check if item actually needs customization, not just that it can be customized
                                                    if (lineProperty != null && ((lineProperty.name.indexOf('_Custom') >= 0 && lineProperty.name != '__SE_CustomItem' && lineProperty.name != '_SE_Custom_FixedPrice')
                                                                                         //|| lineProperty.name.indexOf('TeamStore_') >= 0
                                                                                         || (lineProperty.name.indexOf('__Personalization') >= 0 && lineProperty.value.indexOf('Y') >=0)
                                                                                         || (lineProperty.name.indexOf('_CustomizationId') >= 0 && !isNaN(lineProperty.value) && lineProperty.value.trim() !== '')))
                                                    {
                                                        custom_options_html += '<div class="order-product__option none">' + lineProperty.name + " / " + lineProperty.value + '</div>';//SWIMOUTLET-46773
                                                    } else {
                                                        //htmlLine.querySelector('.order-product__option').removeChild();
                                                    }
                                                    if (lineProperty != null && (lineProperty.name.indexOf('is_final_sale') >= 0)) {
                                                        custom_options_html += '<div class="order-product__option"><span class="order-finalsale__flag">Final Sale</span></div>';
                                                    }


                                                });

                                                htmlLine.querySelector('.order-product__option').outerHTML = custom_options_html; // Custom options
                                            }else{
                                                htmlLine.querySelector('.order-product__option').outerHTML = '';
                                            }

                                            htmlLine.querySelector('.order-product__quantity').textContent = "Quantity:" + line.quantity; // render total purchased quantity
                                            if (order.financial_status.indexOf("refunded") > 0) { // Adjust line item quantity after refund
                                                order.refunds[0].refund_line_items.forEach((line_refund) => { //refund detail
                                                    if (line_refund.line_item_id == line.id) {
                                                        line.quantity = line.quantity - line_refund.quantity;
                                                    }
                                                });
                                                htmlLine.querySelector('.order-product__quantity').textContent = "Quantity:" + (line.quantity); // render actual fulfilled quantity
                                            }

                                            // Add fulfillment status for line items
                                            if (order.fulfillment_status === "fulfilled") {
                                                // Show shipped status for all line items when order is fulfilled
                                                htmlLine.querySelector('.order-product__status--shipped').classList.add('d-flex');
                                                htmlLine.querySelector('.order-product__status--pending').classList.remove('d-flex');
                                            } else if (order.fulfillment_status === "partial") {
                                                // For partial fulfillment, check individual line item fulfillment status
                                                if (line.fulfillment_status === "fulfilled") {
                                                    // This specific line item is fulfilled
                                                    htmlLine.querySelector('.order-product__status--shipped').classList.add('d-flex');
                                                    htmlLine.querySelector('.order-product__status--pending').classList.remove('d-flex');
                                                } else if (line.fulfillment_status === "partial") {
                                                    // This specific line item is partially fulfilled
                                                    htmlLine.querySelector('.order-product__status--shipped').classList.remove('d-flex');
                                                    htmlLine.querySelector('.order-product__status--pending').classList.add('d-flex');
                                                    // Calculate shipped quantity: total quantity - fulfillable quantity
                                                    var shippedQuantity = line.quantity - line.fulfillable_quantity;
                                                    
                                                    // Build the status message
                                                    var statusMessage = 'Item Partially Shipped <span style="font-weight: 500 !important;">' + shippedQuantity + ' of ' + line.quantity + ' items shipped</span>';
                                                    
                                                    // Get delivery information and add to status message
                                                    var deliveryInfo = getDeliveryInformation(line);
                                                    if (deliveryInfo) {
                                                        statusMessage += ' <span style="font-weight: 500 !important;">' + deliveryInfo + '</span>';
                                                    }
                                                    
                                                    // Update the pending text to show specific partial status
                                                    htmlLine.querySelector('.order-product__status--pending .order-product__status-text').innerHTML = statusMessage;
                                                } else { // entire line item is unfulfilled
                                                    // This specific line item is unfulfilled (fulfillment_status is null)
                                                    htmlLine.querySelector('.order-product__status--shipped').classList.remove('d-flex');
                                                    htmlLine.querySelector('.order-product__status--pending').classList.add('d-flex');
                                                    
                                                    // Build the status message for unfulfilled items
                                                    var statusMessage = 'Item Pending';
                                                    
                                                    // Get delivery information and add to status message
                                                    var deliveryInfo = getDeliveryInformation(line);
                                                    if (deliveryInfo) {
                                                        statusMessage += ' <span style="font-weight: 500 !important;">' + deliveryInfo + '</span>';
                                                    }
                                                    
                                                    // Update the pending text for unfulfilled items
                                                    htmlLine.querySelector('.order-product__status--pending .order-product__status-text').innerHTML = statusMessage;
                                                }
                                            } else {
                                                // Show pending status for unfulfilled orders
                                                htmlLine.querySelector('.order-product__status--shipped').classList.remove('d-flex');
                                                htmlLine.querySelector('.order-product__status--pending').classList.add('d-flex');
                                                
                                                // Build the status message for unfulfilled orders
                                                var statusMessage = 'Item Pending';
                                                
                                                // Get delivery information and add to status message
                                                var deliveryInfo = getDeliveryInformation(line);
                                                if (deliveryInfo) {
                                                    statusMessage += ' <span style="font-weight: 500 !important;">' + deliveryInfo + '</span>';
                                                }
                                                
                                                // Update the pending text for unfulfilled orders
                                                htmlLine.querySelector('.order-product__status--pending .order-product__status-text').innerHTML = statusMessage;
                                            }

                                            //SWIMOUTLET-46773

                                            // When you done this will return as string again
                                            var HTMLlineItem = htmlLine.body.innerHTML;
                                            var myDivItem = document.createElement("div");
                                            myDivItem.className = 'order-product__row';
                                            myDivItem.innerHTML = HTMLlineItem;
                                            if(is_Custom_LineId){
                                                //myDivItem.style.opacity = 0.6;
                                                myDivItem.style.display = "none";
                                            }
                                            document.querySelector('.' + order.name + ' .order-product-inner').appendChild(myDivItem);



                                        })
                                        document.querySelector('.' + order.name + ' .order-qty .order__value').textContent = qty; // Total quantity entire orders, don't change even refunded
                                        //Show customization time line SWIMOUTLET-46773
                                        if (isCustomOrder){
                                            // Get customization shipping message from the first line item that has it
                                            var customizationMessage = "";
                                            order.line_items.forEach((line) => {
                                                var deliveryInfo = getDeliveryInformation(line);
                                                if (deliveryInfo && !customizationMessage) {
                                                    customizationMessage = deliveryInfo;
                                                }
                                            });
                                            
                                            if (customizationMessage) {
                                                var customeTimeText = document.createElement('span');
                                                customeTimeText.className = 'order__customization';
                                                customeTimeText.innerHTML = customizationMessage;
                                                document.querySelector('.' + order.name + ' .order-date').appendChild(customeTimeText);
                                            }
                                        }

                                    })

                                    /* document.querySelectorAll('.order-product-more').forEach(btnViewMoreItems => btnViewMoreItems.addEventListener('click',function(){ // order list page
                                        this.parentElement.classList.toggle('expanded');
                                        if(this.querySelector('span').textContent == 'View More'){
                                            this.querySelector('span').textContent = 'View Less';
                                        }else{
                                            this.querySelector('span').textContent = 'View More';
                                        }
                                    })); */

                                    // Pagination
                                    var metaData = JSON.parse(_data.Meta.message);
                                    var totalPage = parseInt(metaData.totalpage); // temporarilly use this field
                                    var ordercount = parseInt(metaData.ordercount);
                                    if (ordercount > 0) {
                                        //document.querySelector(".ordercount").textContent = "("+ordercount+")"; Temporarilly hide
                                    }
                                    if (totalPage > 0) {
                                        var HTMLnewPaging = "";
                                        for (var i = 1; i <= totalPage; i++) {
                                            var parser = new DOMParser();
                                            var htmlDocPaging = parser.parseFromString(paginationitem, 'text/html');
                                            htmlDocPaging.querySelector('.page-link').textContent = i; // Page number
                                            var url = "?view=order";

                                            // Hold search query (if any)
                                            if (SearchQuery) {
                                              url += "&q=" + SearchQuery;
                                            }
                                            
                                            // Keep recentMonths (if not null)
                                            if (RecentMonths != null) {
                                              url += "&lastmonths=" + RecentMonths;
                                            }
                                            
                                            // Finally add page param
                                            url += "&page=" + i;
                                            
                                            if (getParameterByName("page") == null) { // Resolve first page
                                                if (i == 1) {
                                                    htmlDocPaging.querySelector('.page-link').setAttribute("href", "#"); // Current page
                                                    htmlDocPaging.querySelector('.page-item').setAttribute("aria-current", "page"); // Current page
                                                    htmlDocPaging.querySelector('.page-item').classList.add("active");
                                                } else {
                                                    htmlDocPaging.querySelector('.page-link').setAttribute("href", url); // Other page
                                                    htmlDocPaging.querySelector('.page-item').setAttribute("title", "Navigate to page " + i); // Other page
                                                }
                                            }
                                            if (getParameterByName("page") != null) {
                                                if (parseInt(getParameterByName("page")) == i) {
                                                    htmlDocPaging.querySelector('.page-link').setAttribute("href", "#"); // Current page
                                                    htmlDocPaging.querySelector('.page-item').setAttribute("aria-current", "page"); // Current page
                                                    htmlDocPaging.querySelector('.page-item').classList.add("active");
                                                } else {
                                                    htmlDocPaging.querySelector('.page-link').setAttribute("href", url); // Other page
                                                    htmlDocPaging.querySelector('.page-item').setAttribute("title", "Navigate to page " + i); // Other page
                                                }
                                            }

                                            HTMLnewPaging += htmlDocPaging.body.innerHTML;
                                        }

                                        // When you done this will return as string again
                                        var myUl = document.createElement("ul");
                                        myUl.className = 'pagination justify-content-center';
                                        myUl.innerHTML = HTMLnewPaging;
                                        document.querySelector('.pagination-orders').appendChild(myUl);
                                    }


                                } else {
                                    showElement('.noorder');
                                }
                                console.log("Get orders sucessfully");
                                hideElement('.so-loading');
                            });
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                        hideElement('.so-loading');

                    });
            }
        })


}


function getProductURL(url) {
    //AHA! - AI - Generated
    var parts = url.split("-");
    var numberIndex = -1;

    // Find the position of the number in the URL
    for (var i = 0; i < parts.length; i++) {
        if (!isNaN(parts[i]) && parts[i].trim() !== "") {
            numberIndex = i;
            break;
        }
    }

    // If no number is found, return the original URL
    if (numberIndex === -1) {
        return url;
    }

    // Get the URL from the position 0 to the position of the number
    var newParts = parts.slice(0, numberIndex + 1);
    return newParts.join("-");
    
}

//Fundraiser

function getFundraiserOverall(){
    const loading = document.getElementById('fundraiserLoading');
    loading.style.display = 'block';
    let TeamID = Cookies.get("dashboard_teamid");
    if(TeamID == undefined) TeamID = 0;

    const noFundraisers = document.querySelector('.empty-no-fundraisers');
    const fundraiserLanding = document.querySelector('#fundraiser-landing');
    //noFundraisers.style.display = 'none';
    //fundraiserLanding.style.display = 'none';

    const noFundDiv = document.querySelector('#noFundDiv');
    const startFund = document.querySelectorAll('[title="START A FUNDRAISER"]');
    const mobileStartFund = document.querySelector('#mobileStartButton');
    var moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var body = {
                    'l_ShopifyCustomerId': ShopifyCustomerId,
                    'i_ShopifySECustomerId': ShopifySECustomerId ,
                    'TeamID' : TeamID
                };
                var url =  SEEndpointURL + 'api/teamstore/fundraiser';
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(body),
                    })
                    .then(
                        function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with this request. Status Code: ' +
                                    response.status);
                                return;
                            }
                            response.json().then(function(_data) {
                                if (_data.Meta.message == "success") {
                                    // check right to access feature
                                    if (_data.Data.FundraiserCampaigns != null && _data.Data.FundraiserCampaigns.length > 0 && _data.Data.FundraiserCampaigns[0].CampaignSummary.FundraiserID == -2){
                                        alert('You are not super admin of any team');
                                        fundraiserLanding.innerHTML = '';
                                        noFundDiv.innerHTML = '';
                                        return;
                                    }
                                    if (_data.Data.FundraiserCampaigns != null && _data.Data.FundraiserCampaigns.length > 0 && _data.Data.FundraiserCampaigns[0].CampaignSummary.FundraiserID == -1){
                                        alert('This feature is limited access for affiliate team type');
                                        fundraiserLanding.innerHTML = '';
                                        noFundDiv.innerHTML = '';
                                        return;
                                    }

                                    const itemsSoldEle = document.getElementById('items-sold-number');
                                    const totalEaisedEle = document.getElementById('total-raised-amount');
                                    const activeStoreInfoEle = document.getElementById('activeStoreInfo');
                                    const fundraiserBodyEle = document.getElementById('fundraiserBody');

                                    let fundraiserBodyHTML = '';
                                    itemsSoldEle.innerText = _data.Data.TotalOrders;
                                    totalEaisedEle.innerText = moneyFormatter.format(_data.Data.TotalSaleAmount);

                                    let activeStoreInfo = "There is no Store";

                                    if (_data.Data.activeStore < 1){
                                        noFundDiv.classList.add('btn-create-team');
                                        startFund.forEach(ele => {
                                            ele.href = '/pages/affiliate-store';
                                            ele.innerText = 'CREATE A TEAM STORE';
                                        });
                                        mobileStartFund.href = '/pages/affiliate-store';
                                        mobileStartFund.innerText = 'CREATE A TEAM STORE';
                                    }
                                    else if (_data.Data.allowFundraiser != 'Y'){
                                        activeStoreInfo = "";
                                        noFundDiv.classList.add('btn-contact-us');
                                        startFund.forEach(ele => {
                                            ele.href = '/pages/teams#contactus';
                                            ele.setAttribute('target','_blank');
                                            ele.innerText = 'CONTACT US TO ENROLL';
                                        });
                                        mobileStartFund.href = '/pages/teams#contactus';
                                        mobileStartFund.setAttribute('target','_blank');
                                        mobileStartFund.innerText = 'CONTACT US TO ENROLL';
                                    }
                                    else {
                                        activeStoreInfo = _data.Data.activeStore+ " of "+ _data.Data.totalStore +" Stores Active";
                                        noFundDiv.classList.add('btn-start-fund');
                                        startFund.forEach(ele => {
                                            ele.href = '/account?view=fundraiser&action=create&step=set-goals';
                                            ele.innerText = 'START A FUNDRAISER';
                                        });
                                        if (isMobile()){
                                            noFundDiv.querySelector('a').href = 'javascript:void(0);';
                                            noFundDiv.querySelector('a').setAttribute('onclick', "alert('Create and manage your fundraiser is currently available on a desktop experience.')");
                                        }
                                        mobileStartFund.href = 'javascript:void(0);';
                                        mobileStartFund.setAttribute('onclick', "alert('Create and manage your fundraiser is currently available on a desktop experience.')");
                                        mobileStartFund.innerText = 'START A FUNDRAISER';
                                    }

                                    activeStoreInfoEle.innerText = activeStoreInfo;

                                    if ( _data.Data.FundraiserCampaigns != null && _data.Data.FundraiserCampaigns.length > 0){
                                        fundraiserLanding.style.display = 'block';

                                        _data.Data.FundraiserCampaigns.forEach(Campaign => {
                                            //set status store class
                                            let statusClass = "";
                                            let settingOnclick = "";
                                            let moreProductsBtns = "";
                                            let moreProductsBtnsAttr = isMobile() ?
                                                                        `href="javascript:void(0)" onclick="alert('Create and manage your fundraiser is currently available on a desktop experience.')"`
                                                                        :`href="/account?view=fundraiser&action=update&step=select-products&id=${Campaign.CampaignSummary.FundraiserID}"`;
                                            let CampaignStaus = "";
                                            let completeProductsBtn = "";
                                            if (Campaign.CampaignSummary.Status.toUpperCase() == "ACTIVE"){
                                                CampaignStaus = "ACTIVE"
                                                statusClass = "fund-active";
                                                settingOnclick = `onclick="editFundraiser(${Campaign.CampaignSummary.FundraiserID})"`;
                                                if (isMobile() && Campaign.CampaignSummary.HasPendingProducts == 'Y'){
                                                    completeProductsBtn =
                                                        `<div class="fund-complete-pending">
                                                            <a href="javascript:void(0)" onclick="alert('Create and manage your fundraiser is currently available on a desktop experience.')" class="btn btn-primary">Complete pending products</a>
                                                        </div>`;
                                                }
                                                else if (Campaign.CampaignSummary.HasPendingProducts == 'Y'){
                                                    completeProductsBtn =
                                                        `<div class="fund-complete-pending">
                                                            <a href="/account?view=fundraiser&action=update&step=set-pricing&id=${Campaign.CampaignSummary.FundraiserID}" class="btn btn-primary">Complete pending products</a>
                                                        </div>`;
                                                }
                                                moreProductsBtns = `<div id="moreProductsBtns" style="display: none;" class="fund-product-more">
                                                                        <div class="fund-product-more-inner">
                                                                            ${completeProductsBtn}
                                                                            <div class="fund-add-more">
                                                                                <a ${moreProductsBtnsAttr} class="btn btn-primary ga4-tracking-button" data-label="go-to-fundraiser-products">Add more product</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>`;
                                            }
                                            else if (Campaign.CampaignSummary.Status.toUpperCase() == "SCHEDULED"){
                                                CampaignStaus = "SCHEDULED";
                                                statusClass = "fund-scheduled";
                                                settingOnclick = `onclick="editFundraiser(${Campaign.CampaignSummary.FundraiserID})"`;
                                                if (isMobile() && Campaign.CampaignSummary.HasPendingProducts == 'Y'){
                                                    completeProductsBtn =
                                                        `<div class="fund-complete-pending">
                                                            <a href="javascript:void(0)" onclick="alert('Create and manage your fundraiser is currently available on a desktop experience.')" class="btn btn-primary">Complete pending products</a>
                                                        </div>`;
                                                }
                                                else if (Campaign.CampaignSummary.HasPendingProducts == 'Y'){
                                                    completeProductsBtn =
                                                        `<div class="fund-complete-pending">
                                                            <a href="/account?view=fundraiser&action=update&step=set-pricing&id=${Campaign.CampaignSummary.FundraiserID}" class="btn btn-primary">Complete pending products</a>
                                                        </div>`;
                                                }
                                                moreProductsBtns = `<div id="moreProductsBtns" style="display: none;" class="fund-product-more">
                                                                        <div class="fund-product-more-inner">
                                                                            ${completeProductsBtn}
                                                                            <div class="fund-add-more">
                                                                                <a ${moreProductsBtnsAttr} class="btn btn-primary ga4-tracking-button" data-label="go-to-fundraiser-products">Add more product</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>`;
                                            }
                                            else if (Campaign.CampaignSummary.Status.toUpperCase() == "ENDED"){
                                                CampaignStaus = "ENDED";
                                                statusClass = "fund-ended";
                                                settingOnclick = "";
                                            }
                                            else if (Campaign.CampaignSummary.Status.toUpperCase() == "NEW"){
                                                CampaignStaus = 'In Progess... Finish My Fundraiser';
                                                if(isMobile()){
                                                    settingOnclick = `alert('Create and manage your fundraiser is currently available on a desktop experience.')`;
                                                }
                                                else if(Campaign.CampaignSummary.StepWorkingOn == 'STEP2-1'){
                                                    settingOnclick = `onclick="window.location.href ='/account?view=fundraiser&action=update&step=select-products&id=${Campaign.CampaignSummary.FundraiserID}'"`;
                                                }
                                                else if(Campaign.CampaignSummary.StepWorkingOn == 'STEP2-2'){
                                                    settingOnclick = `onclick="window.location.href ='/account?view=fundraiser&action=update&step=design-products&id=${Campaign.CampaignSummary.FundraiserID}'"`;
                                                }
                                                else if(Campaign.CampaignSummary.StepWorkingOn == 'STEP3'){
                                                    settingOnclick = `onclick="window.location.href ='/account?view=fundraiser&action=update&step=set-pricing&id=${Campaign.CampaignSummary.FundraiserID}'"`;
                                                }
                                                else if(Campaign.CampaignSummary.StepWorkingOn == 'STEP4'){
                                                    settingOnclick = `onclick="window.location.href ='/account?view=fundraiser&action=update&step=summary&id=${Campaign.CampaignSummary.FundraiserID}'"`;
                                                }
                                                else {
                                                    settingOnclick = `onclick="window.location.href ='/account?view=fundraiser&action=update&step=set-goals&id=${Campaign.CampaignSummary.FundraiserID}'"`;
                                                }
                                            }


                                            let Goal = moneyFormatter.format(Campaign.CampaignSummary.Goal);
                                            let Sales = 0;
                                            if (Campaign.CampaignSummary.Sales != null){
                                                Sales = Campaign.CampaignSummary.Sales;
                                            }
                                            Sales = moneyFormatter.format(Sales);

                                            let startDate = Campaign.CampaignSummary.StartDate.split(' ')[0].split('/');
                                            let startDateDisplay = ('0' + startDate[0]).slice(-2) + '/' + ('0' + startDate[1]).slice(-2) + '/' + startDate[2];
                                            let startDateInput = startDate[2] + '-' + ('0' + startDate[0]).slice(-2) + '-' + ('0' + startDate[1]).slice(-2);

                                            let endDate = Campaign.CampaignSummary.EndDate.split(' ')[0].split('/');
                                            let endDateDisplay = ('0' + endDate[0]).slice(-2) + '/' + ('0' + endDate[1]).slice(-2) + '/' + endDate[2];
                                            let endDateInput = endDate[2] + '-' + ('0' + endDate[0]).slice(-2) + '-' + ('0' + endDate[1]).slice(-2);

                                            fundraiserBodyHTML +=
                                                `<div class="fundraiser-group" fundraiser-data="${Campaign.CampaignSummary.FundraiserID}">
                                                <div class="fundraiser-group-title">
                                                <div class="fund-group-title-inner sed-flex">
                                                    <div class="fund-group-title-team d-flex-item">
                                                    <span class="fund-group-team">${Campaign.CampaignSummary.FundraiserName}</span>
                                                    </div>
                                                    <div class="fund-group-title-status d-flex-item">
                                                        <span class="fund-group-line">|</span><span class="fund-group-status ${statusClass}">${CampaignStaus}</span>
                                                    </div>
                                                    <div class="fund-group-title-icons d-flex-item">
                                                        <span class="fund-icon fund-icon-setting" ${settingOnclick}>
                                                            <svg id="settings_black_24dp" xmlns="http://www.w3.org/2000/svg" class="icon icon--setting" width="24" height="24" viewBox="0 0 24 24">
                                                                <path id="Path_13265" data-name="Path 13265" d="M0,0H24V24H0Z" fill="none"/>
                                                                <path id="Path_13266" data-name="Path 13266" d="M19.14,12.94A7.074,7.074,0,0,0,19.2,12a5.777,5.777,0,0,0-.07-.94l2.03-1.58a.491.491,0,0,0,.12-.61L19.36,5.55a.488.488,0,0,0-.59-.22l-2.39.96a7.064,7.064,0,0,0-1.62-.94L14.4,2.81a.484.484,0,0,0-.48-.41H10.08a.474.474,0,0,0-.47.41L9.25,5.35a7.22,7.22,0,0,0-1.62.94L5.24,5.33a.477.477,0,0,0-.59.22L2.74,8.87a.455.455,0,0,0,.12.61l2.03,1.58a5.563,5.563,0,0,0-.02,1.88L2.84,14.52a.491.491,0,0,0-.12.61l1.92,3.32a.488.488,0,0,0,.59.22l2.39-.96a7.064,7.064,0,0,0,1.62.94l.36,2.54a.492.492,0,0,0,.48.41h3.84a.466.466,0,0,0,.47-.41l.36-2.54a6.859,6.859,0,0,0,1.62-.94l2.39.96a.477.477,0,0,0,.59-.22l1.92-3.32a.463.463,0,0,0-.12-.61ZM12,15.6A3.6,3.6,0,1,1,15.6,12,3.611,3.611,0,0,1,12,15.6Z" fill="#767676"/>
                                                            </svg>
                                                        </span>
                                                        <span class="fund-btn-save" style="display: none;">
                                                            <button type="button" class="btn btn-primary btn--select" onclick="saveFundrasiser(${Campaign.CampaignSummary.FundraiserID})"><span>SAVE</span></button>
                                                        </span>
                                                        <span class="fund-icon fund-icon-delete" onclick="confirmToDelete('campaign', ${Campaign.CampaignSummary.FundraiserID},'')">
                                                            <svg id="delete_forever_black_24dp" xmlns="http://www.w3.org/2000/svg" class="icon icon--delete" width="24" height="24" viewBox="0 0 24 24">
                                                                <path id="Path_13262" data-name="Path 13262" d="M0,0H24V24H0Z" fill="none"/>
                                                                <path id="Path_13263" data-name="Path 13263" d="M0,0H24V24H0Z" fill="none"/>
                                                                <path id="Path_13264" data-name="Path 13264" d="M6,19a2.006,2.006,0,0,0,2,2h8a2.006,2.006,0,0,0,2-2V7H6Zm2.46-7.12,1.41-1.41L12,12.59l2.12-2.12,1.41,1.41L13.41,14l2.12,2.12-1.41,1.41L12,15.41,9.88,17.53,8.47,16.12,10.59,14ZM15.5,4l-1-1h-5l-1,1H5V6H19V4Z" fill="#767676"/>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                </div>
                                                <div class="fundraiser-group-content">
                                                <div class="fundraiser-group-info">
                                                    <div class="fund-group-info-inner sed-flex">
                                                    <div class="fund-group-info-item fund-start-date">
                                                        <div class="fund-group-info-label">Start Date</div>
                                                        <div class="fund-group-info-ilabel" id="startDateValue">${startDateDisplay}</div>
                                                        <div class="form-edit-fund" style="display: none;">
                                                            <input type="date" id="startDateInput" class="form-control" name="Startdate" value="${startDateInput}" placeholder="Start Date" aria-label="Start date" onchange="fundraiserValidate(this,'startDate')" errorMsg>
                                                        </div>
                                                    </div>
                                                    <div class="fund-group-info-item fund-end-date">
                                                        <div class="fund-group-info-label">End Date</div>
                                                        <div class="fund-group-info-ilabel" id="endDateValue">${endDateDisplay}</div>
                                                        <div class="form-edit-fund" style="display: none;">
                                                            <input type="date" id="endDateInput" class="form-control" name="Enddate" value="${endDateInput}" placeholder="Enter Date" aria-label="End date" onchange="fundraiserValidate(this,'endDate')" errorMsg>
                                                        </div>
                                                    </div>
                                                    <div class="fund-group-info-item fund-amount-raised">
                                                        <div class="fund-group-info-label">Amount Raised</div>
                                                        <div class="fund-group-info-ilabel">${Sales}</div>
                                                    </div>
                                                    <div class="fund-group-info-item fund-fundraising-goal">
                                                        <div class="fund-group-info-label">Your Fundraising Goal</div>
                                                        <div class="fund-group-info-ilabel" id="goalValue">${Goal}</div>
                                                        <div class="form-edit-fund" style="display: none;">
                                                            <input type="text" id="goalInput" class="form-control" value="${Goal.replace('$','')}" aria-label="Your Fundraising Goal" onchange="fundraiserValidate(this,'goal')" errorMsg>
                                                            <span class="form-control-txt">$</span>
                                                        </div>
                                                        <div class="form-check" style="display: none;">
                                                            <input class="form-check-input" id="shareProgressInput" type="checkbox" ${Campaign.CampaignSummary.ShareProcess == "Y" ? "checked" : "" }>
                                                            <label class="form-check-label" for="">Promote Fundraiser</label>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                <div class="fundraiser-group-product">
                                                <div class="fund-group-phead">
                                                        <div class="fund-product-head">Products</div>
                                                        ${moreProductsBtns}
                                                    </div>
                                                <div class="fund-product-inner">
                                                <div class="fund-product-list">
                                                    <div class="row">`;

                                            Campaign.ProductList = Campaign.ProductList.filter(product => product.Status == "Active");
                                            if (Campaign.ProductList.length > 0){
                                                Campaign.ProductList.forEach(product => {
                                                    let productLink = `/products/${product.Handle}/?storeid=${product.StoreID}&custom=${product.CustomProductID}`
                                                    let imgPath = product.ImgPath;
                                                    if (imgPath == ''){
                                                        imgPath = document.querySelector('#comingSoonPhotoUrl').value;
                                                    }
                                                    let Cost = moneyFormatter.format(product.Cost);
                                                    let Price = moneyFormatter.format(product.Price);
                                                    let earning = ((parseFloat(product.Cost) - parseFloat(product.Price))* 97/100).toFixed(2);
                                                    let displayProductName = product.CustomProductName == null || product.CustomProductName == '' ? product.ProductName : product.CustomProductName + ' - ' + product.ProductName;

                                                    fundraiserBodyHTML +=
                                                    `<div class="col-6 col-md-4 col-lg-3">
                                                        <div class="fund-product-item" product-data="${product.CustomProductID}">
                                                            <div class="fund-product-img">
                                                                <a href="${productLink}"><img alt="" class="img-lazyload" width="163" src="${imgPath}"></a>
                                                            </div>
                                                            <div class="fund-product-title">
                                                                <a href="${productLink}">${displayProductName}</a>
                                                            </div>
                                                            <div class="fund-product-price" id="productCost">
                                                                <div class="fund-p-label">Fundraiser Price:</div>
                                                                <div class="fund-p-price">${Cost}</div>
                                                            </div>
                                                            <div class="fund-product-y-earn" id="productEarning">
                                                                You Earn <span>$${earning}</span> per item!
                                                            </div>
                                                            <div class="fund-product-price" id="currentPrice" style="display: none;">
                                                                <div class="fund-p-label">Current Price:</div>
                                                                <div class="fund-p-price">${Price}</div>
                                                            </div>
                                                            <div class="fund-product-set-price" id="priceEdit" style="display: none;">
                                                                <div class="fund-p-label">Set Fundraiser Price:</div>
                                                                <div class="fund-p-input"><input type="text" class="form-control" value="${Cost}" onchange="fundraiserPriceOnChange(this,${product.Price})" errorMsg></div>
                                                            </div>
                                                            <div class="fund-product-delect-item" id="deleteButton" style="display: none;"><a href="javascript:void(0);" class = "ga4-tracking-button" data-label="fundraiser-delete-item" onclick="confirmToDelete('product', ${Campaign.CampaignSummary.FundraiserID}, ${product.CustomProductID})">Delete this item</a></div>
                                                        </div>
                                                    </div>`;
                                                })
                                            }
                                            else {
                                                fundraiserBodyHTML += 'There is no product available'
                                            }

                                            fundraiserBodyHTML += `</div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>`;

                                        });
                                    }
                                    else if (_data.Data.FundraiserCampaigns != null && _data.Data.FundraiserCampaigns.length == 0){
                                        //Display empty-no-fundraisers page
                                        noFundraisers.style.display = "block";
                                    }
                                    else console.log('Wrong in API Data.FundraiserCampaigns');

                                    fundraiserBodyEle.innerHTML = fundraiserBodyHTML;

                                    loading.style.display = 'none';
                                }
                                else {
                                    console.log('Something wrong: ' + _data.Meta.message);
                                }
                            });
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });
            }

        }).catch(err => {
            console.log("Error when getting API key of getFundraiserOverall in se-myaccount.js" + err);
        });
}


function editFundraiser(fundraiserID){
    const fundraiserEle = document.querySelector('[fundraiser-data="'+ fundraiserID +'"]');
    if(fundraiserEle == null){
        console.error('cannot find store');
        return;
    }
    const saveButton = fundraiserEle.querySelector('.fund-btn-save');
    const settingButton = fundraiserEle.querySelector('.fund-icon-setting');
    const startDateValue = fundraiserEle.querySelector('#startDateValue');
    const startDateInput = fundraiserEle.querySelector('#startDateInput');
    const endDateValue = fundraiserEle.querySelector('#endDateValue');
    const endDateInput = fundraiserEle.querySelector('#endDateInput');
    const goalValue = fundraiserEle.querySelector('#goalValue');
    const goalInput = fundraiserEle.querySelector('#goalInput');
    const shareProgressInput = fundraiserEle.querySelector('#shareProgressInput');
    const moreProductsBtns = fundraiserEle.querySelector('#moreProductsBtns');

    const productCostEles = fundraiserEle.querySelectorAll('#productCost');
    const productEarningEles = fundraiserEle.querySelectorAll('#productEarning');
    const currentPriceEles = fundraiserEle.querySelectorAll('#currentPrice')
    const priceEditEles = fundraiserEle.querySelectorAll('#priceEdit');
    const deleteButtons = fundraiserEle.querySelectorAll('#deleteButton');

    //hide elements
    settingButton.style.display = "none";
    startDateValue.style.display = "none";
    endDateValue.style.display = "none";
    goalValue.style.display = "none";
    productCostEles.forEach(ele => ele.style.display = "none");
    productEarningEles.forEach(ele => ele.style.display = "none");

    //display element
    saveButton.style.display = "inline";
    if (moreProductsBtns != null) moreProductsBtns.style.display = "block";
    startDateInput.parentElement.style.display = "block";
    endDateInput.parentElement.style.display = "block";
    goalInput.parentElement.style.display = "block";
    shareProgressInput.parentElement.style.display = "block";
    currentPriceEles.forEach(ele => ele.style.display = "block");
    priceEditEles.forEach(ele => ele.style.display = "block");
    deleteButtons.forEach(ele => ele.style.display = "block");
}

function saveFundrasiser(fundraiserID){
    const fundraiserEle = document.querySelector('[fundraiser-data="'+ fundraiserID +'"]');
    if(fundraiserEle == null){
        console.error('cannot find store');
        return;
    }
    const saveButton = fundraiserEle.querySelector('.fund-btn-save');
    const settingButton = fundraiserEle.querySelector('.fund-icon-setting');
    const endDateValue = fundraiserEle.querySelector('#endDateValue');
    const endDateInput = fundraiserEle.querySelector('#endDateInput');
    const startDateValue = fundraiserEle.querySelector('#startDateValue');
    const startDateInput = fundraiserEle.querySelector('#startDateInput');
    const goalValue = fundraiserEle.querySelector('#goalValue');
    const goalInput = fundraiserEle.querySelector('#goalInput');
    const shareProgressInput = fundraiserEle.querySelector('#shareProgressInput');
    const moreProductsBtns = fundraiserEle.querySelector('#moreProductsBtns');

    const productCostEles = fundraiserEle.querySelectorAll('#productCost');
    const productEarningEles = fundraiserEle.querySelectorAll('#productEarning');
    const currentPriceEles = fundraiserEle.querySelectorAll('#currentPrice')
    const priceEditEles = fundraiserEle.querySelectorAll('#priceEdit');
    const deleteButtons = fundraiserEle.querySelectorAll('#deleteButton');

    //validation
    let errorMsg = "";
    if(endDateInput.getAttribute('errorMsg') != ''){
        errorMsg = endDateInput.getAttribute('errorMsg');
    }
    if(startDateInput.getAttribute('errorMsg') != ''){
        errorMsg = startDateInput.getAttribute('errorMsg');
    }
    if(goalInput.getAttribute('errorMsg') != ''){
        errorMsg = goalInput.getAttribute('errorMsg');
    }
    const productEle = fundraiserEle.querySelectorAll('[product-data]');
    for (let i = 0; i < productEle.length; i++){
        if(productEle[i].querySelector('[errorMsg]').getAttribute('errorMsg') != ''){
            errorMsg = productEle[i].querySelector('[errorMsg]').getAttribute('errorMsg');
            productEle[i].querySelector('[errorMsg]').style.color = 'red';
            break;
        }
    }
    if (errorMsg != ''){
        openPopupMessage(errorMsg);
        return;
    }

    let productData = [];
    priceEditEles.forEach((ele, i)=> {
        if (ele.querySelector('input').value.trim() != productCostEles[i].querySelector('.fund-p-price').innerText.trim()){
            productData.push({
                "ProductId" : ele.parentElement.getAttribute('product-data'),
                "CurrentPrice" : "",
                "Price" : ele.querySelector('input').value.trim().replace('$','').replace(',','')
            });
            productCostEles[i].querySelector('.fund-p-price').innerText = ele.querySelector('input').value;
        }
    })

    let endDate = endDateInput.value;
    let startDate = startDateInput.value;
    let goal = goalInput.value.trim() == null ? goalValue.value : goalInput.value;
    let shareProgressValue = shareProgressInput.checked ? 'Y' : 'N'

    const loading = document.getElementById('fundraiserLoading');
    loading.style.display = 'block';
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var body = {
                    'l_ShopifyCustomerId': ShopifyCustomerId,
                    'i_ShopifySECustomerId': ShopifySECustomerId,
                    'fundraiserID': fundraiserID,
                    'endDate' :endDate,
                    'goal' :goal,
                    'shareProgress':shareProgressValue,
                    'productList': productData,
                    'startDate': startDate
                };
                var url = SEEndpointURL + 'api/teamstore/updateFundraiser';
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(body),
                    })
                    .then(
                        function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with this request. Status Code: ' +
                                    response.status);
                                return;
                            }

                            let startDateDisplay = startDate.split('-');
                            startDateDisplay = parseInt(startDateDisplay[1]) + '/' + parseInt(startDateDisplay[2]) + '/' + startDateDisplay[0];
                            startDateValue.innerText = startDateDisplay;
                            let endDateDisplay = endDate.split('-');
                            endDateDisplay = parseInt(endDateDisplay[1]) + '/' + parseInt(endDateDisplay[2]) + '/' + endDateDisplay[0];
                            endDateValue.innerText = endDateDisplay;
                            goalValue.innerText = goal;

                            // //display elements
                            settingButton.style.display = "inline";
                            startDateValue.style.display = "block";
                            endDateValue.style.display = "block";
                            goalValue.style.display = "block";
                            productCostEles.forEach(ele => ele.style.display = "block");
                            productEarningEles.forEach(ele => ele.style.display = "block");

                            //hide element
                            saveButton.style.display = "none";
                            startDateInput.parentElement.style.display = "none";
                            endDateInput.parentElement.style.display = "none";
                            goalInput.parentElement.style.display = "none";
                            shareProgressInput.parentElement.style.display = "none";
                            if (moreProductsBtns != null) moreProductsBtns.style.display = "none";
                            currentPriceEles.forEach(ele => ele.style.display = "none");
                            priceEditEles.forEach(ele => ele.style.display = "none");
                            deleteButtons.forEach(ele => ele.style.display = "none");

                            loading.style.display = 'none';
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of saveFundrasiser function in se-myaccount.js" + err);
        });
}

function confirmToDelete(type, fundraiserID, productID){
    //Only apply on landing
    if(type == "product"){
        const customPopup = document.getElementById("PopupMessage");
        customPopup.classList.add('fund-popup-size-l', 'remove-item');
        customPopup.querySelector('#redInfo').innerHTML = 'This cannot be undone.';
        customPopup.querySelector(".fund-popup-message-btn[data-id='customize']").innerHTML = `<a href="javascipt:void(0)" onclick="deleteProduct(${fundraiserID}, ${productID})" class="btn btn-secondary mr-2">DELETE ITEM</a><a href="javascipt:void(0)" onclick="closePopupMessage()" class="btn btn-secondary">KEEP ITEM</a>`;
        openPopupMessage({
            type: "customize-action",
            message: `Deleting this item will remove it from your store.`,
            hasRedMess: true,
        });
    }
    else if (type == "campaign"){
        const fundraiserName = document.querySelector("[fundraiser-data=\"" + fundraiserID + "\"]").querySelector('.fund-group-team').innerText;
        const customPopup = document.getElementById("PopupMessage");
        customPopup.classList.add('fund-popup-size-l', 'cancel-fundraiser');
        customPopup.querySelector('#redInfo').innerHTML = 'This will delete your current settings.';
        customPopup.querySelector(".fund-popup-message-btn[data-id='customize']").innerHTML = `<a href="javascript:void(0)" onclick="deleteCampaign(${fundraiserID})" class="btn btn-secondary mr-2">CANCEL FUNDRAISER</a><a href="javascript:void(0)" onclick="closePopupMessage()" class="btn btn-secondary">KEEP FUNDRAISER</a>`;
        openPopupMessage({
            type: "customize-action",
            message: `Are you sure you want to cancel ${fundraiserName} Fundraiser?`,
            hasRedMess: true,
        });
    }
    else return;
}

function deleteProduct(fundraiserID, productCode){
    const productEle = document.querySelector('[product-data="'+ productCode +'"]');
    if(productEle == null){
        console.error('cannot find product');
        return;
    }
    const loading = document.getElementById('fundraiserLoading');
    loading.style.display = 'block';
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var body = {
                    'l_ShopifyCustomerId': ShopifyCustomerId,
                    'i_ShopifySECustomerId': ShopifySECustomerId,
                    'fundraiserID': fundraiserID,
                    'ProductCode': productCode
                };
                var url = SEEndpointURL + 'api/teamstore/deleteFundraiserProduct';
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(body),
                    })
                    .then(
                        function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with this request. Status Code: ' +
                                    response.status);
                                return;
                            }
                            if (window.location.search == '?view=fundraiser') productEle.parentElement.remove();
                            else productEle.remove();
                            loading.style.display = 'none';
                            closePopupMessage();
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of deleteProduct function in se-myaccount.js" + err);
        });
}

function deleteCampaign(fundraiserID){
    const fundraiserEle = document.querySelector('[fundraiser-data="'+ fundraiserID +'"]');
    if(fundraiserEle == null){
        console.error('cannot find store');
        return;
    }
    const loading = document.getElementById('fundraiserLoading');
    loading.style.display = 'block';
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var body = {
                    'l_ShopifyCustomerId': ShopifyCustomerId,
                    'i_ShopifySECustomerId': ShopifySECustomerId,
                    'fundraiserID': fundraiserID
                };
                var url = SEEndpointURL + 'api/teamstore/deleteFundraiser';
                fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'apitoken': my_token,
                            'skey': ShopifyCustomerKey
                        },
                        body: JSON.stringify(body),
                    })
                    .then(
                        function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with this request. Status Code: ' +
                                    response.status);
                                return;
                            }
                            //response.json().then(function(_data) {});
                            fundraiserEle.remove();
                            loading.style.display = 'none';
                            closePopupMessage();
                        }
                    )
                    .catch(function(err) {
                        console.log('Fetch Error :-S', err);
                    });
            }
        }).catch(err => {
            console.log("Error when getting API key of deleteCampaign function in se-myaccount.js" + err);
        });
}

function loadFundraiserItemToSetPrice(){
    const loading = document.getElementById('fundraiserLoading');
    loading.style.display = 'block';

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    let fundrasierID = params.id;

    let create = SEFundraiser['create'];
    fundrasierID = (fundrasierID == undefined || fundrasierID == null) ? create['storage']['id'] : fundrasierID;
    if (fundrasierID == undefined || fundrasierID == null){
        openPopupMessage('There is no fundraiser to set up currently. Please start to create new fundraiser');
        return;
    }
    document.getElementById('addMoreBtn').disabled = false;
    document.getElementById('addMoreBtn').href = '/account?view=fundraiser&action=create&step=select-products&id=' + fundrasierID
    getLoginApiToken()
        .then(my_token => {
            if (my_token != "") {
                var body = {
                    'l_ShopifyCustomerId': ShopifyCustomerId,
                    'i_ShopifySECustomerId': ShopifySECustomerId,
                    'fundraiserID': fundrasierID
                };
                var url = SEEndpointURL + 'api/fundraiser/productlisttosetprice';
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'apitoken': my_token,
                        'skey': ShopifyCustomerKey
                    },
                    body: JSON.stringify(body),
                })
                .then(function(response) {
                    if (response.status == 400) { // Bad request
                        console.log('Looks like there was a problem with authentication. Status Code: ' +
                            response.status);
                        Cookies.remove("apitoken"); //clean to reset
                        return;
                    }
                    if (response.status !== 200) {
                        console.log('Looks like there was a problem with this request. Status Code: ' + response.status);
                        return;
                    }
                    response.json().then(function(_data) {
                        if (_data.Meta.message == "success") {
                            let fundraiserBodyHTML = "";
                            const fundraiserProductListEle = document.querySelector('#fundraiserProductList');
                            const submitPriceButton = document.querySelector('#submitPrice');

                            if (_data.Data.ProductList != null && _data.Data.ProductList.length > 0){
                                fundraiserBodyHTML += '<div class="row">';
                                _data.Data.ProductList.forEach(product => {
                                    var moneyFormatter = new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD',
                                    });

                                    let Price = moneyFormatter.format(parseFloat(product.Price)/100);
                                    let Cost = product.Cost != '0' ? moneyFormatter.format(parseFloat(product.Cost)) : '';
                                    let earning = ((parseFloat(product.Cost) - parseFloat(parseFloat(product.Price)/100))* 97/100);
                                    earning = earning > 0 ? ('You Earn <span>$'+ String(earning.toFixed(2)) +'</span> per item!') : '';
                                    let productLink = `products/${product.Handle}/?storeid=${product.StoreID}&custom=${product.CustomProductID}`
                                    let imgPath = product.ImgPath;
                                    if (imgPath == ''){
                                        imgPath = document.querySelector('#comingSoonPhotoUrl').value;
                                    }
                                    let displayProductName = product.CustomProductName == null || product.CustomProductName == '' ? product.ProductName : product.CustomProductName + ' - ' + product.ProductName;

                                    fundraiserBodyHTML += `<div class="col-6 col-md-4 col-lg-3" product-data="${product.CustomProductID}">
                                            <div class="fund-product-item">
                                            <div class="fund-product-img">
                                                <a href="${productLink}"><img alt="" class="img-lazyload" width="163" src="${imgPath}"></a>
                                            </div>
                                            <div class="fund-product-title">
                                                <a href="${productLink}">${displayProductName}</a>
                                            </div>
                                            <div class="fund-product-price">
                                                <div class="fund-p-label">Price:</div>
                                                <div class="fund-p-price" id="priceValue">${Price}</div>
                                            </div>
                                            <div class="fund-product-set-price">
                                                <div class="fund-p-label">Set Fundraiser Price:</div>
                                                <div class="fund-p-input"><input id="priceInput" type="text" class="form-control" value="${Cost}" placeholder="Enter price you want to sell this product" onkeyup="fundraiserPriceOnChange(this,${product.Price/100})" errorMsg></div>
                                            </div>
                                            <div class="fund-product-y-earn">${earning}
                                            </div>
                                            <div class="fund-product-delect-item"><a href="javascript:void(0);" class = "ga4-tracking-button" data-label="fundraiser-delete-item" onclick="deleteProduct(${fundrasierID},${product.CustomProductID})">Delete this item</a></div>
                                            </div>
                                        </div>`
                                })
                                fundraiserBodyHTML += '</div>';
                            }
                            else{
                                fundraiserBodyHTML = "There are no products to set price. "
                                fundraiserBodyHTML += "Please complete previous steps before setting up price for products "
                                submitPriceButton.style.cursor = 'default';
                                submitPriceButton.style.pointerEvents = 'none';

                            }
                            fundraiserProductListEle.innerHTML = fundraiserBodyHTML;
                            loading.style.display = 'none';
                            document.getElementById('submitPrice').disabled = false;
                            document.getElementById('saveBtn').disabled = false;
                        }
                        else {
                            console.log('Something wrong: ' + _data.Meta.message);
                        }
                    });
                })
                .catch(function(err) {
                    console.log('Fetch Error :-S', err);
                });
            }

        }).catch(err => {
            console.log("Error when getting API of loadFundraiserItemToSetPrice in se-myaccount.js" + err);
        });
}

function submitFundraiserPrice(type){
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    let fundrasierID = params.id;

    let create = SEFundraiser['create'];
    fundrasierID = (fundrasierID == undefined || fundrasierID == null) ? create['storage']['id'] : fundrasierID;

    let submitData = [];
    let storageData = [];
    let errorMsg = "";
    let isError = false;
    const productListEles = document.querySelectorAll('[product-data]');

    if (type == 'submit'){
        for (let i = 0; i < productListEles.length; i++){
            let currentErr = productListEles[i].querySelector('[errorMsg]').getAttribute('errorMsg')
            if(currentErr != ''){
                errorMsg = currentErr;
                productListEles[i].querySelector('[errorMsg]').style.color = 'red';
                isError = true;
                break;
            }

            if(productListEles[i].querySelector('#priceInput').value.trim().replace('$','').replace(',','') == ''){
                errorMsg = 'Please enter all fundraiser price'
                isError = true;
                break;
            }
        }
    }
    else if (type == 'saveProgress'){
        for (let i = 0; i < productListEles.length; i++){
            let currentErr = productListEles[i].querySelector('[errorMsg]').getAttribute('errorMsg')
            if(currentErr != '' && currentErr != 'Fundraiser price is missing'){
                errorMsg = currentErr;
                productListEles[i].querySelector('[errorMsg]').style.color = 'red';
                isError = true;
                break;
            }
        }
    }
    else return;

    if(isError){
        openPopupMessage(errorMsg);
        return;
    }
    else{
        productListEles.forEach(ele => {
            let productData = {
                "ProductId": ele.getAttribute('product-data'),
                "CurrentPrice": ele.querySelector('#priceValue').innerText.trim().replace('$','').replace(',',''),
                "Price": ele.querySelector('#priceInput').value.trim().replace('$','').replace(',',''),
            }
            let fullProductData = {
                'name' :ele.querySelector('.fund-product-title a').innerText,
                'image':ele.querySelector('.fund-product-img img').getAttribute('src'),
                'price': ele.querySelector('#priceValue').innerText.trim().replace('$','').replace(',',''),
                'price-fundraiser': ele.querySelector('#priceInput').value.trim().replace('$','').replace(',',''),
                'url': ele.querySelector('.fund-product-img a').getAttribute('href')
            }
            submitData.push(productData);
            storageData.push(fullProductData);
        });

        if (submitData.length < 1) return;

        const loading = document.getElementById('fundraiserLoading');
        loading.style.display = 'block';
        getLoginApiToken()
            .then(my_token => {
                if (my_token != "") {
                    var body = {
                        'l_ShopifyCustomerId': ShopifyCustomerId,
                        'i_ShopifySECustomerId': ShopifySECustomerId,
                        'fundraiserID': fundrasierID,
                        'type' : type,
                        'productList': submitData,
                    };
                    var url = SEEndpointURL  + 'api/fundraiser/updateFundraiserPrice';
                    fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'apitoken': my_token,
                                'skey': ShopifyCustomerKey
                            },
                            body: JSON.stringify(body),
                        })
                        .then(function(response) {
                            if (response.status == 400) { // Bad request
                                console.log('Looks like there was a problem with authentication. Status Code: ' +
                                    response.status);
                                Cookies.remove("apitoken"); //clean to reset
                                return;
                            }
                            if (response.status !== 200) {
                                console.log('Looks like there was a problem with this request. Status Code: ' + response.status);
                                return;
                            }
                            response.json().then(function(_data) {
                                if (_data.Meta.message == "success" && _data.Data == "OK" ) {
                                    if (type == 'submit'){
                                       // save in storage
                                        create['storage']['products'] = storageData;
                                        SEFundraiser['SetStorage']("create", create['storage']);
                                        //redirect to next step
                                        loading.style.display = 'none';
                                        window.location.href = "/account?view=fundraiser&action=create&step=summary&id=" + fundrasierID;
                                    }
                                    else if (type == 'saveProgress'){
                                        //redirect to dashboard
                                        loading.style.display = 'none';
                                        window.location.href = "/account?view=fundraiser";
                                    }
                                }
                                else {
                                    alert("Something error");
                                    console.log('Something wrong: ' + _data.Meta.message);
                                }
                            });
                        })
                        .catch(function(err) {
                            console.log('Fetch Error :-S', err);
                        });
                }
            }).catch(err => {
                console.log("Error when getting API of updating price in se-myaccount.js" + err);
            });
    }
}

function openPopupMessage(data) {
    const ErrorText = document.getElementById('ErrorText');
    const PopupMessage = document.getElementById('PopupMessage');
    let type = "";
    let message = data;
    let hasRedMess = "";
    if (typeof data === "object") {
        type = data['type'];
        message = data['message'];
        hasRedMess = data['hasRedMess'] == null ? false : data['hasRedMess'];
    }
    if (PopupMessage.querySelector(".fund-popup-message-btn[data-id='customize']") != null)
        PopupMessage.querySelector(".fund-popup-message-btn[data-id='customize']").style.display = (type === "customize-action" ? "block" : "none");
    if (PopupMessage.querySelector(".fund-popup-message-btn:not([data-id='customize'])") != null)
        PopupMessage.querySelector(".fund-popup-message-btn:not([data-id='customize'])").style.display = (type !== "customize-action" ? "block" : "none");
    if (PopupMessage.querySelector('#redInfo') != null){
        PopupMessage.querySelector('#redInfo').style.display = (hasRedMess ? 'block' : 'none');
    }
    ErrorText.innerHTML = message;
    PopupMessage.style.display = "block";
}

function closePopupMessage(){
    const ErrorText = document.getElementById('ErrorText');
    const PopupMessage = document.getElementById('PopupMessage');
    PopupMessage.classList.remove('fund-popup-size-l', 'remove-item', 'cancel-fundraiser')
    PopupMessage.style.display = 'none';
    ErrorText.innerHTML = "";
}

function fundraiserPriceOnChange(el, currentPrice){
    el.setAttribute("errorMsg","");
    el.style.color = '';
    let value = el.value.replace('$','').replace(',','');
    const earningEle = el.parentElement.parentElement.parentElement.querySelector('.fund-product-y-earn');
    if (value == ''){
        el.setAttribute("errorMsg","Fundraiser price is missing");
        earningEle.innerHTML = '';
        return;
    }
    else if (isNaN(value) ||  value == null){
        el.setAttribute("errorMsg","Please enter correct price");
        earningEle.innerHTML = '';
        return;
    }
    else if (value < currentPrice){
        el.setAttribute("errorMsg","Minimum price must be above the current price");
        earningEle.innerHTML = '';
        return;
    }
    else if (value > (currentPrice*5)){
        el.setAttribute("errorMsg","Maximum price must be less than 5x the current price");
        earningEle.innerHTML = '';
        return;
    }
    else{
        let earning = (parseFloat(value) - parseFloat(currentPrice))* 97/100;
        earningEle.innerHTML = 'You Earn <span>$'+ String(earning.toFixed(2)) +'</span> per item!'
    }
    el.setAttribute("errorMsg","");
}

function fundraiserValidate(el, type){
    if(type == 'startDate'){
        let inputValue = Date.parse(el.value);
        let startDateMin = new Date();
        startDateMin.setDate(startDateMin.getDate() + 2);
        if(isNaN(inputValue)){
            el.setAttribute("errorMsg","Invalid date time");
            return;
        }
        if (inputValue < startDateMin){
            el.setAttribute("errorMsg","Start Date must be at least 2 days in the future to account for the approval of custom designs. Contact teams@swimoutlet.com if you need help.");
            return;
        }
    }
    if (type == 'endDate'){
        let inputValue = Date.parse(el.value);
        let startDateValue = Date.parse(el.parentElement.parentElement.parentElement.querySelector('#startDateValue').innerText);
        let endDateMax = new Date(startDateValue);
        endDateMax.setDate(endDateMax.getDate() + 60);
        let endDateMin = new Date(startDateValue);
        endDateMin.setDate(endDateMin.getDate() + 7);

        if(isNaN(inputValue)){
            //openPopupMessage('Invalid date time');
            el.setAttribute("errorMsg","Invalid date time");
            return;
        }
        if (inputValue < startDateValue){
            //openPopupMessage('End date cannot be before start date');
            el.setAttribute("errorMsg","End date cannot be before start date");
            return;
        }
        if (inputValue < endDateMin){
            //openPopupMessage('Your fundraiser must be active for at least 7 days');
            el.setAttribute("errorMsg","Your fundraiser must be active for at least 7 days");
            return;
        }
        if (inputValue > endDateMax){
            openPopupMessage('We recommend scheduling your fundraiser between 7 and 60 days...');
        }
    }
    else if (type == 'goal'){
        if(parseFloat(el.value.replace('$','').replace(',','')) < 0){
            //openPopupMessage('Goal cannot be negative');
            el.setAttribute("errorMsg","Goal cannot be negative");
            return;
        }
        if (isNaN(el.value.replace('$','').replace(',',''))){
            //openPopupMessage('Invalid goal value');
            el.setAttribute("errorMsg","Invalid goal value");
            return;
        }
    }
    el.setAttribute("errorMsg","");
}

//End Of Fundraiser

function isMobile(){
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];

    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
}

function documentReady(fn) {
    if (document.readyState != 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}


var serialize = function(form) {
    var field,
        l,
        s = [];

    if (typeof form == 'object' && form.nodeName == "FORM") {
        var len = form.elements.length;

        for (var i = 0; i < len; i++) {
            field = form.elements[i];
            //if (field.name && !field.disabled && field.type != 'button' && field.type != 'file' && field.type != 'hidden' && field.type != 'reset' && field.type != 'submit') {
            if (field.name && !field.disabled && field.type != 'button' && field.type != 'file' && field.type != 'reset' && field.type != 'submit') {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length;

                    for (var j = 0; j < l; j++) {
                        if (field.options[j].selected) {
                            s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[j].value);
                        }
                    }
                } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                    s[s.length] = encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
                }
            }
        }
    }
    return s.join('&').replace(/%20/g, '+');
};

function showRecoverPasswordForm() {
    window.scrollTo(0,0);
    showElement('#recover_customer_password');
    hideElement('#customer_login');
    hideElement('.do-have-account');
    hideElement("#modal-signin");
}

function hideRecoverPasswordForm() {
    hideElement('#recover_customer_password');
    showElement('#customer_login');
    showElement('.do-have-account');
}

document.addEventListener('DOMContentLoaded', function() {
    var applyButton = document.querySelector('.btn.btn-secondary');
    if (applyButton) {
        applyButton.addEventListener('click', function() {
            var emailInput = document.querySelector('.form-control.account-email');
            var customer_email = emailInput ? emailInput.value : '';
            var codeInput = document.getElementById('coupon-code');
            var code_value = codeInput ? codeInput.value : '';
            sessionStorage.setItem('scrollPosition', window.pageYOffset);

            Process_USMS_DiscountCode(customer_email, code_value);
        });
    }

    var message = sessionStorage.getItem('applyMessage');
    var scrollPosition = sessionStorage.getItem('scrollPosition');
    if (message) {
        let usms_code_msg = document.querySelector('[data-se="apply-usms-code-msg"]');
        usms_code_msg.innerHTML = message;
        usms_code_msg.classList.remove("d-none");
        sessionStorage.removeItem('applyMessage');
    }
    if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition));
        sessionStorage.removeItem('scrollPosition');
    }
});

function Process_USMS_DiscountCode(customer_email, code_value){
    getApiToken()
    .then(my_token => {
        if (my_token != "") {
            var _dataRe = {
                'reg_code': code_value,
                'reg_email': customer_email
            };
            var _urlRe = window.SEEndpointURL + 'api/product/usms?key=' + Math.random();
            fetch(_urlRe, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json', 
                    'apikey': my_token,
                },
                body: JSON.stringify(_dataRe),
            })
            .then(response => {
                if (response.status !== 200) {
                    console.log('Cannot apply the code for now. Please try again later! Status Code: ' + response.status);
                    return;
                }
                return response.json();
            })
            .then(_response => {
                if (_response && _response.Data) {
                    sessionStorage.setItem('applyMessage', _response.Data);

                    let usms_code_msg = document.querySelector('[data-se="apply-usms-code-msg"]');
                    usms_code_msg.innerHTML = _response.Data;
                    usms_code_msg.classList.remove("d-none");

                    if (!(_response.Data.includes("does not exist") || _response.Data.includes("used already") || _response.Data.includes("no longer valid") || _response.Data.includes("Your new SO+ membership has been extended"))) {
                        let newUrl = `/account?view=membership&discount=${code_value}`;
                        window.location.href = newUrl;
                    }
                }
            })
            .catch(function(err) {
                console.log('Fetch Error :-S', err);
            });
        }
    }).catch(err => {
        console.log("Error when getting API key: " + err);
    });
}

documentReady(function() {
    // code here
    // if(ShopifyCustomerId > 0){
    //     setTimeout(function(){
    //         checkTeamStoreAcc();
    //     }, 1000);//should run after verify token
    // }

    //SWIMOUTLET-53511-Team Super Admin login to go to Splash Page first before redirecting to target URL
    var returnUrl_Element = document.querySelector('input[name="return_url"]');
    if (returnUrl_Element)
    {
        var returnUrl_Value = '';
        returnUrl_Value = returnUrl_Element.value;
        if (returnUrl_Value != '' && ShopifyCustomerId == 0)
        {
            //Cookies.set("return_url_after_splash_page", returnUrl_Value, { expires: 1, path: '/', secure: true });
            document.getElementsByName("return_url")[0].value = "/pages/switcher-splash-page";
        }
    }

    //SWIMOUTLET-52215-Update Landing Page After Team Account Sign In - for case multipass with team account
    if (Cookies.get("repLoginAccountSwitcher") && IsTeamAccount && Cookies.get("isRedirectToTeamDashBoardPageForMultipassTeamAccount"))
    {
        var teamDashBoardUrl = origin + "/account?view=team-dashboard";
        window.location.href = teamDashBoardUrl;
        Cookies.remove("isRedirectToTeamDashBoardPageForMultipassTeamAccount");

        //https://jira.spiraledge.com/browse/SWIMOUTLET-59886 Fix Log In As Functions for Kustomer, Logistics
        if (CustomerEmail) {
            let getTeamId = CustomerEmail.replace(/\D/g, ""); 
            Cookies.set("dashboard_teamid", getTeamId, { expires: 1, path: '/', secure: true });
        }
    }
    if(IsTeamAccount && Cookies.get("storeid"))
    {
        var storeid_cookie = Cookies.get("storeid");
        if (window.location.search == '?view=fundraiser'
        && IsTeamAccount
        && storeid_cookie.indexOf('0') == 0)
        {
            var createTeamStoreUrl = origin + "/account?view=team-store";
            window.location.href = createTeamStoreUrl;
        }
    }
    //SWIMOUTLET-52215 Update Landing Page After Team Account Sign In
    if (IsTeamAccount && Cookies.get("isRedirectToTeamDashBoardPage"))
    {
        if(Cookies.get("previousPageAfterLoginTeamAccount")) //SWIMOUTLET-53640
        {
            var previousPageAfterLoginTeamAccount = Cookies.get("previousPageAfterLoginTeamAccount");
            window.location.href = previousPageAfterLoginTeamAccount;
        }
        // else
        // {
        //     var teamDashBoardUrl = origin + "/account?view=team-dashboard";
        //     window.location.href = teamDashBoardUrl;
        // }
        Cookies.remove("isRedirectToTeamDashBoardPage");
        Cookies.remove("previousPageAfterLoginTeamAccount");
    }
    if (window.location.pathname == '/account/register') {
        document.querySelector(".btn--register").addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            var errorList = "";
            if (!document.getElementById("first_name").value) {
                errorList += "<li class='Alert__ErrorItem'><strong>First name</strong> can\'t be blank</li>";
            }
            if (!document.getElementById("last_name").value) {
                errorList += "<li class='Alert__ErrorItem'><strong>Last name</strong> can\'t be blank</li>";
            }
            if (!document.getElementById("email").value) {
                errorList += "<li class='Alert__ErrorItem'><strong>Email</strong> can\'t be blank</li>";
            }
            if (document.getElementById("email").value) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,10})$/;
                if (!regex.test(document.getElementById("email").value)) {
                    errorList += "<li class='Alert__ErrorItem'><strong>Email</strong> is invalid</li>";
                }
            }
            if (!document.getElementById("password").value) {
                errorList += "<li class='Alert__ErrorItem'><strong>Password</strong> can\'t be blank</li>";
            }
            if (document.getElementById("password").value && document.getElementById("password").value.length < 5) {
                errorList += "<li class='Alert__ErrorItem'><strong>Password</strong> is too short (minimum is 5 characters)</li>";
            }
            if (errorList == "") {

                document.querySelector("#create_customer").submit();
            } else {
                console.log(errorList);
                document.getElementById("se-registerform-error").innerHTML = '<ul class=\'Alert__ErrorList\'>' + errorList + '</ul>';
                showElement("#se-registerform-error");
                return false;
            }
        });
    }
    //SWIMOUTLET-53687 Redirect back to BYT/FYT once logged in from BYT/FYT pages
    if (ShopifyCustomerId > 0 && !IsTeamAccount) {
        if (Cookies.get("isRedirectToFYT")){
            var url = origin + "/pages/teams";
            window.location.href = url;
            Cookies.remove("isRedirectToFYT")
        }
        else if (Cookies.get("isRedirectToBYT")){
            var url = origin + "/pages/build-your-team";
            window.location.href = url;
            Cookies.remove("isRedirectToBYT")
        }
    }

    if (window.location.pathname == '/account/login' || window.location.pathname == '/account/register') {
        document.getElementById("show-password").addEventListener('click', function(event) {
            if (document.getElementsByName("customer[password]")[0].getAttribute("type") == "password") {
                this.textContent = "Hide";
                document.getElementsByName("customer[password]")[0].setAttribute("type", "text");
            } else {
                this.textContent = "Show";
                document.getElementsByName("customer[password]")[0].setAttribute("type", "password");
            }
        });
    }

    if (window.location.hash == '#recover') { showRecoverPasswordForm(); }
    if (window.location.pathname == '/account/login' && ((Cookies.get('resetpwd_popup') == undefined) || (Cookies.get('resetpwd_popup') == ""))) {
        //showElement("#modal-signin");
        //Cookies.set('resetpwd_popup', 'Y', { expires: 365, path: '/', secure: true }); // Prevent showing again
    }

    if (ShopifyCustomerId > 0 && window.location.pathname.indexOf('/account/orders/') == 0){ // display customization - my account order detail SWIMOUTLET-46773
        document.querySelectorAll(".order-product__row").forEach((eachrow)=>{
            if(eachrow.querySelector(".TeamStore_Photo")){
                eachrow.querySelector(".order-product-img img").setAttribute("src",eachrow.querySelector(".TeamStore_Photo").textContent);
            }
            if(eachrow.querySelector(".TeamStore_StoreId") && eachrow.querySelector(".TeamStore_CustomizationId")){ // customization link
                eachrow.querySelectorAll(".order-product__url").forEach((productLink) =>{
                    var customizationLink = productLink.getAttribute("masterlink") + "?storeid="+eachrow.querySelector(".TeamStore_StoreId").textContent + "&custom="+eachrow.querySelector(".TeamStore_CustomizationId").textContent;
                    productLink.setAttribute("href",customizationLink);
                });
            }
        });
    }


    if (ShopifyCustomerId > 0 && (window.location.search.indexOf('view=order') > 0 || window.location.search == "") && window.location.pathname != '/account/addresses' && window.location.pathname.indexOf('/account/orders') ==-1) {
        // Get the input field
        var input = document.getElementsByName('SearchOrders')[0];
        if(input){
            input.addEventListener("keyup", function(event) {
                // Number 13 is the "Enter" key on the keyboard
                if (event.keyCode === 13) {
                    // Cancel the default action, if needed
                    event.preventDefault();
                    // Trigger the button element with a click
                    document.getElementById("gosearchorder").click();
                }
            });
        }
        document.getElementsByName("SearchOrders")[0].addEventListener('click', function(event) {
            event.preventDefault();
            document.querySelector("#clearsearch").classList.add("d-block");
            document.querySelector("#gosearchorder").classList.add("d-block");
        });
        document.body.addEventListener('click', function() {
            hideElement('.timeframe-div');
            document.querySelector('.dropdown-alt').classList.remove('dropdown-alt--open');
        });
        document.querySelector(".timeframe-btn").addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            showElement('.timeframe-div');
            document.querySelector('.dropdown-alt').classList.add('dropdown-alt--open');
        });
        document.querySelector(".timeframe-btn-mobile").addEventListener('click', function(event) {
            event.preventDefault();
            event.stopPropagation();
            document.querySelector('.dropdown-alt').classList.add('dropdown-alt--open');
            showElement('.timeframe-div');
        });

        document.querySelector("#clearsearch").addEventListener('click', function(event) {
            event.preventDefault();
            document.getElementsByName('SearchOrders')[0].value = "";
        });
        document.querySelector("#gosearchorder").addEventListener('click', function(event) {
            event.preventDefault();
            window.location.href = '/account?view=order&q=' + document.getElementsByName('SearchOrders')[0].value;
        });
        // document.getElementsByName("Orders_RecentMonths")[0].addEventListener('change',function(event){
        //     event.preventDefault();
        //     window.location.href='/account?view=order&lastmonths='+document.getElementsByName('Orders_RecentMonths')[0].value;
        // });

        // Timeframe selection: read the li's `value` even if the user clicks the inner label
        document.querySelectorAll(".timeframe-li").forEach(selectTimeFrame => selectTimeFrame.addEventListener('click', function(event) {
            event.preventDefault();
            // `this` might be the LI or an inner LABEL (some markup has the same class on the label)
            var value = this.getAttribute('value');
            if (!value) {
                var li = this.tagName && this.tagName.toLowerCase() === 'li' ? this : this.closest('li');
                if (li) value = li.getAttribute('value');
            }
            // Fallback to empty string to avoid 'null' being appended
            if (value === null || typeof value === 'undefined') value = '';
            window.location.href = '/account?view=order&lastmonths=' + value;
        }));

        getOrderList();
    }

    if (ShopifyCustomerId > 0 && (window.location.search.indexOf('?view=storecredit') >= 0 || window.location.search.indexOf('?view=payment')) >= 0) {
        getGcByUser(ShopifyCustomerId, CustomerEmail);
    }

    if (ShopifyCustomerId > 0 && window.location.search == '?view=membership') {
        LoyaltyProgram();
    }

    if (ShopifyCustomerId > 0 && (window.location.search.indexOf('view=personal') > 0) || window.location.pathname == '/account/addresses') { //Bind States and Country
        document.querySelectorAll('select[name ="address[country]"]').forEach(selectCountryBox => selectCountryBox.addEventListener('onload', function(ele) {
            if (this.getAttribute('data-default')) {
                this.value = this.getAttribute('data-default');
            }
        }));

        document.querySelectorAll('select[name ="address[country]"]').forEach(selectCountryBox => selectCountryBox.addEventListener('change', function(ele) {
            var provincesData = this.options[this.selectedIndex].getAttribute('data-provinces');
            //console.log(provincesData);
            var selectEleProvinces = this.closest(".modal--address").querySelector('select[name ="address[province]"]');
            if (provincesData) {
                var provincesJson = JSON.parse(provincesData);
                for (i = selectEleProvinces.options.length - 1; i >= 0; i--) {
                    selectEleProvinces.remove(i);
                }
                for (var i in provincesJson) {
                    //console.log(i, provincesJson[i]);
                    var isSelected = "";
                    if (selectEleProvinces.getAttribute('data-default') == provincesJson[i][0]) {
                        isSelected = 'selected';
                    }
                    var opt = document.createElement('option');
                    opt.value = provincesJson[i][0];
                    opt.innerHTML = provincesJson[i][1];
                    opt.selected = isSelected;
                    selectEleProvinces.appendChild(opt);
                }
                selectEleProvinces.style.display = 'block';
            } else {
                selectEleProvinces.style.display = 'none';
            }
        }));

        document.querySelectorAll('.btn-del-addr').forEach(btnDelAddr => btnDelAddr.addEventListener('click', function() {
            document.querySelectorAll('.address-delete-form').forEach(formDelAddr => formDelAddr.classList.remove('active'));
            this.closest('.address-delete-form').classList.add('active');
            showElement('#modal-address-delete');
            document.querySelector('.PageOverlay').classList.add('is-visible');
        }));

        document.querySelectorAll('.btn-edit-addr').forEach(btnEditAddr => btnEditAddr.addEventListener('click', function() {
            var addressIdModal = this.getAttribute('aria-controls');
            showElement('#' + addressIdModal);
            document.querySelector('.PageOverlay').classList.add('is-visible');
            sendEvent('#' + addressIdModal + ' select[name ="address[country]"]', 'onload');
            sendEvent('#' + addressIdModal + ' select[name ="address[country]"]', 'change');
        }));

        if (window.location.search.indexOf('view=personal') > 0) { // Prevent form submit on landing page
            // document.querySelectorAll('.address-delete-form').forEach(formDelAddr => formDelAddr.addEventListener('submit',function(event){ // Delete form
            //     event.preventDefault();
            //     //var dataForm = serialize(this);//"_method=delete";
            //     //console.log(dataForm);

            //     var url = this.getAttribute('action');
            //     var myData = {
            //         '_method': 'delete'
            //     };
            //     var request = new XMLHttpRequest();
            //     request.open('POST', url, true);
            //     //request.setRequestHeader( 'Content-Type', 'application/x-www-form-urlencoded' );
            //     request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            //     request.onload = function() {
            //         if (this.status >= 200 && this.status < 400) {
            //             // Success!
            //             var resp = this.response;
            //             console.log('Success');
            //             window.location = "/account?view=personal";
            //         } else {
            //             // We reached our target server, but it returned an error
            //             console.log(' We reached our target server, but it returned an error');

            //         }
            //     };
            //     request.onerror = function(error) {
            //         // There was a connection error of some sort
            //         console.log('There was a connection error of some sort');
            //     };
            //     request.send(JSON.stringify(myData));

            // }));

            document.querySelector('#address_form_new').addEventListener('submit', function(event) { // Register form to add new address -
                event.preventDefault();
                var dataForm = serialize(this);
                //if (!document.getElementById("new-default-address").checked){
                dataForm += "&address%5Bdefault%5D=2"; // Must have to add sucessfully, but the value is meaningless
                //}
                console.log(dataForm);

                var url = '/account/addresses';

                var request = new XMLHttpRequest();
                request.open('POST', url, true);
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                request.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success!
                        var resp = this.response;
                        console.log('Success');
                        window.location = "/account?view=personal";
                    } else {
                        // We reached our target server, but it returned an error
                        console.log(' We reached our target server, but it returned an error');

                    }
                };
                request.onerror = function(error) {
                    // There was a connection error of some sort
                    console.log('There was a connection error of some sort');
                };
                request.send(JSON.stringify(dataForm));

            });
            //show message if cust unsubscribe from all list SO-43706
            getSubscriptionDetail(CustomerEmail, "", "");
        }
    }

    if (ShopifyCustomerId > 0 && window.location.search == '?view=fundraiser') {
        sessionStorage.removeItem('fundraiser');
        getFundraiserOverall();
    }

    if (ShopifyCustomerId > 0 && (window.location.search.includes('?view=fundraiser&action=create&step=set-pricing') || window.location.search.includes('?view=fundraiser&action=update&step=set-pricing'))) {
        loadFundraiserItemToSetPrice();
    }

    //SWIMOUTLET-50516-Create Storefront Account Switcher for Team Admins
    if (ShopifyCustomerId > 0 && window.location.pathname.indexOf('/account') >= 0) {
        getAccountList(ShopifyCustomerId);
    }

    

    const url_params = new URLSearchParams(window.location.search.toLowerCase());
    const url_pview = url_params.get('view');

    // For: Team Dashboard
    (function() {
        if (url_pview != 'team-dashboard') {
            return;
        }
        var stop = ".container--myaccount";
        var dtop = document.querySelector(stop);

        let tpl = document.querySelector('template[data-id="popup-ts-inquiry"]');
        if (!tpl) { return; }
        let $ts_inquiry = tpl.content.firstElementChild;
        $ts_inquiry.setAttribute('id', 'popup-ts-inquiry');
        dtop.insertAdjacentElement('beforeend', $ts_inquiry);

        let ts_landing = '.container--myaccount';
        let elmt_landing = document.querySelector(ts_landing);
        if(elmt_landing){
            elmt_landing.querySelector('.team-subject').addEventListener('change', function (e) {
                setCaseDisposition();
            });

            elmt_landing.querySelector('#contactemail').addEventListener('click', function (e) {
                changetype('Email');
            });

            elmt_landing.querySelector('#contactphone').addEventListener('click', function (e) {
                changetype('Phone');
            });

            elmt_landing.querySelectorAll('.ts-contact')
            .forEach(el => { el.addEventListener('click', function (e) {
                resetform();
            })});

            elmt_landing.querySelector('.btnSendContact').addEventListener('click', function (e) {
                sendContact();
            });

            if (window.location.href.indexOf("#contactus") > 0){
                resetform();
            }
            if (window.location.href.indexOf("msg=y") > 0){
                elmt_landing.querySelector(".modal--teamsale--alter").style.display = "block";
            }
        }

        function resetform(){
            removeValid();
            elmt_landing.querySelector(".modal--teamsale").style.display = "block";
            elmt_landing.querySelector(".team-first-name").value = "";
            elmt_landing.querySelector(".team-email").value = "";
            elmt_landing.querySelector(".team-comment").value = "";
            elmt_landing.querySelector(".team-phone").value = "";
            elmt_landing.querySelector(".team-phone").style.display = "none";
            elmt_landing.querySelector(".team-state").value = "";
            elmt_landing.querySelector(".team-subject").value = "";
            elmt_landing.querySelector("#contactemail").checked = true;
            elmt_landing.querySelector("#contactphone").checked = false;
            elmt_landing.querySelector(".modal--teamsale").style.display = "block";
            elmt_landing.querySelector(".modal--teamsale--alter").style.display = "none";
            document.forms["formsalesforce"]?.classList.remove("submitting");
        }

        function removeValid(){
            elmt_landing.querySelector(".team-first-name").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-email").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-comment").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-phone").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-state").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-subject").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-subject").classList.remove("is-invalid");
            elmt_landing.querySelector("#subject").classList.remove("is-invalid");
            elmt_landing.querySelector(".team-phone").classList.remove("is-invalid");
        }

        function setCaseDisposition(){
            var subject = document.querySelector(".team-subject").value;
            if("Team General"==subject)
                document.getElementById("00N3j00000GER5L").value = "Bulk Order Quote";
            else
                document.getElementById("00N3j00000GER5L").value = "";
        }

        function changetype(obj){
            if(obj=='Phone')
            {
                elmt_landing.querySelector(".team-phone").style.display = "block";
                elmt_landing.querySelector("#contactemail").checked = false;
            }
            else
            {
                elmt_landing.querySelector(".team-phone").style.display = "none";
                elmt_landing.querySelector("#contactphone").checked = false;
            }
            document.getElementById("00N3j00000GEQ76").value = obj;
        }

        function sendContact() {
            let dfrm = document.forms["formsalesforce"];
            if (dfrm.classList.contains("submitting")) {
                return false;
            }
            removeValid();
            let name = elmt_landing.querySelector(".team-first-name").value;
            let email= elmt_landing.querySelector(".team-email").value;
            let state= elmt_landing.querySelector(".team-state").value;
            let comment= elmt_landing.querySelector(".team-comment").value;
            let subject= elmt_landing.querySelector("#subject").value;
            let phone = elmt_landing.querySelector(".team-phone").value;
            let selectsubject = elmt_landing.querySelector('.team-subject');
            let option = selectsubject.children[selectsubject.selectedIndex];
            let subtext = option.value;
            let contacttype = document.getElementById("00N3j00000GEQ76").value;

            if(name=="" || email=="" || comment=="" || subject==""||state== "" || subtext ==""|| (contacttype=="Phone" && phone=="")){
                if(name=="")
                {  elmt_landing.querySelector(".team-first-name").classList.add("is-invalid"); }
                if(email=="")
                {  elmt_landing.querySelector(".team-email").classList.add("is-invalid"); }
                if(comment=="")
                {  elmt_landing.querySelector(".team-comment").classList.add("is-invalid"); }
                if(subtext=="")
                {  elmt_landing.querySelector(".team-subject").classList.add("is-invalid"); }
                if(subject=="")
                {  elmt_landing.querySelector("#subject").classList.add("is-invalid"); }
                if(state=="")
                {  elmt_landing.querySelector(".team-state").classList.add("is-invalid"); }
                if(contacttype=="Phone" && phone=="")
                {  elmt_landing.querySelector(".team-phone").classList.add("is-invalid"); }

                alert("Please input your information.");
                return false;
            }
            if(!validateEmail(email)){
                alert("Email invalid");
                return false;
            }
            dfrm.classList.add("submitting");
            dfrm.submit();
        }
    })();

});

async function getCookie(name) {
    let cookies = document.cookie.split(';');
    for(let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim().split('=');
        if (cookie[0] === name) return cookie[1];
    }
    return null;
}
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function deleteCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
async function getApiTokenSignin() {
    let apiKey = await getCookie('apikey');
    if (apiKey) {
        if (apiKey.startsWith('"')) {
            apiKey = JSON.parse(apiKey);
        }
        return apiKey;
    }

    var url = SEEndpointURL + 'api/token?key=' + Math.random();
    return fetch(url)
        .then(response => {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status);
                throw new Error('Problem with apikey-generator: ' + response.statusText);
            }
            return response.json();
        })
        .then(data => {
            setCookie('apikey', data, 7);
            return data;
        });
}

async function loginMethod() {
    const myToken = await getApiTokenSignin();
    if (!myToken) throw new Error("API token is missing or invalid.");

    var customerTagElement = document.getElementById("customerTag");
    var loggedInCustEmailElement = document.getElementById("customerEmail");
    var ShopifyCustomerIdElement = document.getElementById("customerId");

    if (!customerTagElement || !loggedInCustEmailElement || !ShopifyCustomerIdElement) {
        return;
    }

    var customerTagValue = customerTagElement.value;
    var loggedInCustEmail = loggedInCustEmailElement.value;
    var ShopifyCustomerId = ShopifyCustomerIdElement.value;
    
    const myData = {
        "FromSite": "SWIMOUTLET",
        "ShopifyCustomerID": ShopifyCustomerId,
        "ShopifyCustomerEmail": loggedInCustEmail,
        "CustomerSubscription": true,
        "MethodLogin": customerTagValue,
        "CollectionSource": "AccountCreation",
        "IsSaveMothedLogin": true,
    };
    
    const url = SEEndpointURL + 'api/customer/subscription_v2?key=' + Math.random();
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'apikey': myToken,
        },
        body: JSON.stringify(myData),
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    deleteCookie('HasReceive');
    console.log("Login successful.");
}
async function initiateLogin() {
    const hasReceive = await getCookie('HasReceive');
    if (hasReceive) {
        await loginMethod();
    }
}

/**
 * SO-65712: Team account sidebar expand/collapse (icons-only rail).
 * Persists state in localStorage and syncs myaccount-inner-collapsed on .myaccount-inner.
 */
function initTeamSidebarCollapse() {
    var STORAGE_KEY = 'team-sidebar-collapsed';
    function getLeft(btn) {
        if (btn) {
            var left = btn.closest('.account-team--left');
            if (left) return left;
        }
        return document.querySelector('.account-team--left');
    }
    function isCollapsed(btn) {
        var left = getLeft(btn);
        return left && left.classList.contains('account-team--left--collapsed');
    }
    function setCollapsed(collapsed, sourceBtn) {
        var btn = sourceBtn || document.querySelector('[data-sidebar-toggle]');
        var left = getLeft(btn);
        if (!left || !btn) return;
        var inner = left.closest('.myaccount-inner');
        var collapseIcon = btn.querySelector('.sidebar-acc-switcher__collapse-icon-collapse');
        var expandIcon = btn.querySelector('.sidebar-acc-switcher__collapse-icon-expand');
        var openSwitchers = (left || document).querySelectorAll('.sidebar-acc-switcher.show');
        for (var s = 0; s < openSwitchers.length; s++) openSwitchers[s].classList.remove('show');
        if (collapsed) {
            left.classList.add('account-team--left--collapsed');
            if (inner) inner.classList.add('myaccount-inner-collapsed');
            btn.setAttribute('aria-label', 'Expand sidebar');
            btn.setAttribute('title', 'Expand sidebar');
            btn.setAttribute('data-sidebar-collapsed', 'true');
            if (collapseIcon) collapseIcon.hidden = true;
            if (expandIcon) expandIcon.hidden = false;
        } else {
            left.classList.remove('account-team--left--collapsed');
            if (inner) inner.classList.remove('myaccount-inner-collapsed');
            btn.setAttribute('aria-label', 'Collapse sidebar');
            btn.setAttribute('title', 'Collapse sidebar');
            btn.setAttribute('data-sidebar-collapsed', 'false');
            if (collapseIcon) collapseIcon.hidden = false;
            if (expandIcon) expandIcon.hidden = true;
        }
        try { localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false'); } catch (e) {}
        syncTeamSwitcherToggleTooltip();
    }
    document.addEventListener('click', function(e) {
        var btn = e.target && e.target.closest('[data-sidebar-toggle]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        setCollapsed(!isCollapsed(btn), btn);
    });
    var runRestore = function() {
        var btn = document.querySelector('[data-sidebar-toggle]');
        var left = getLeft(btn);
        if (!left || !btn) return;
        try {
            if (localStorage.getItem(STORAGE_KEY) === 'true') setCollapsed(true, btn);
        } catch (err) {}
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runRestore);
    else runRestore();
}

/**
 * Fetch team store URL and set "Visit Team Store" sidebar link on all team account pages
 * (dashboard script only runs on team-dashboard; this runs on personal, payment, etc.)
 */
function updateTeamStoreSidebarLink() {
    var sidebarVisitLink = document.querySelector('a[data-team-store-url]');
    if (!sidebarVisitLink) return;
    var href = (sidebarVisitLink.getAttribute('href') || '').trim();
    if (href && href !== '#') return;
    var teamId = Cookies.get('dashboard_teamid');
    if (teamId === undefined) teamId = 0;
    var affiliateid = Cookies.get('SEAffiliateID');
    if (affiliateid === undefined) affiliateid = 0;
    getLoginApiToken().then(function(token) {
        if (!token) return;
        var content = { affiliateid: affiliateid, sizeoption: '', type: '', teamid: teamId };
        var url = SEEndpointURL + 'api/teamstore/Standardbanner?key=' + Math.random();
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'apitoken': token },
            body: JSON.stringify(content)
        }).then(function(response) {
            if (response.status !== 200) return;
            return response.json();
        }).then(function(_response) {
            if (_response && _response.Data && _response.Data.referal_link) {
                var referal_link = _response.Data.referal_link;
                sidebarVisitLink.href = referal_link;
                sidebarVisitLink.setAttribute('target', '_blank');
                sidebarVisitLink.setAttribute('rel', 'noopener noreferrer');
            }
        }).catch(function(err) {
            console.warn('Visit Team Store link update failed:', err);
        });
    });
}

document.addEventListener("DOMContentLoaded", function() {
    initiateLogin();
    initTeamSidebarCollapse();
    initTeamSwitcherOutsideClose();
    updateTeamStoreSidebarLink();
})
